<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn" v-if="pageLoaded">
    <div v-if="pageLoaded">
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-top m-0 mt-9 rounded-0 bg-purple text-white text-center border-0"
        style="z-index: 2000; opacity: 60%"
        dir="rtl"
      >
        پیشنویس ثبت شد!
      </b-alert>
      <b-card
        v-if="
          $router.currentRoute.path.indexOf(
            '/researcher/completePostDoc/' + this.$route.params.id
          ) == 0
        "
        style="border: 0"
        class="mt-0 mb-0"
      >
        <b-card
          v-if="
            (proposal.status == 'نیاز به تکمیل / اصلاح' ||
              proposal.status == 'پیش نویس') &&
            proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ proposal.adminMessage }}</b-card
        >
        <b-card
          v-if="proposal.status == 'رد شده است'"
          header-bg-variant="danger"
          header-text-variant="white"
          header="دلیل رد"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ rejectMessage }}</b-card
        >
        <div class="d-flex justify-content-center mt-3"></div>
        <b-tabs class="mb-3" pills vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-saveDraft) to save draft -->
            <b-button
              :disabled="isSaving"
              class="mx-1"
              variant="success"
              @click="saveDraft()"
              >ثبت پیشنویس</b-button
            >
            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 10"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <b-tab :title="'حمایت‌های پیشین از دوره‌'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">حمایت‌های پیشین</h4>
              </template>
              <b-form-group>
                <div class="d-flex" dir="ltr">
                  <label
                    for="switch_1"
                    :class="
                      proposal.initialObligation
                        ? 'ml-3 mb-0 done'
                        : 'ml-3 mb-0 required'
                    "
                  >
                    اینجانب تعهد می کنم با مطالعه و آگاهی از
                    <b-button
                      id="downLoad"
                      title="دانلود تعهدات"
                      variant="link"
                      href="/researcher/rules/postDoc/آئین نامه پسادکتری.pdf"
                    >
                      <b-tooltip
                        placement="bottomleft"
                        target="downLoad"
                        triggers="hover"
                        variant="info"
                        >دانلود شیوه‌نامه</b-tooltip
                      >شیوه‌نامه حمایت از دوره‌های پسادکتری ستاد توسعه زیست
                      فناوری </b-button
                    >و طرح تقسیم کار ملی زیست ‌فناوری نسبت به ارسال درخواست در
                    سامانه اقدام می نمایم
                  </label>
                  <b-form-checkbox
                    id="switch_1"
                    v-model="proposal.initialObligation"
                  ></b-form-checkbox>
                </div>
              </b-form-group>
              <hr />
              <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

              <p>
                به ابزار حمایت از مقالات سامانه تقسیم کار ملی خوش آمدید.
                خواهشندیم ابتدا به سوالات زیر پاسخ دهید:
              </p>
              <b-form-group
                label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
                class="done"
              >
                <b-form-radio-group v-model="proposal.initialIsSupported">
                  <b-form-radio :value="true">بله</b-form-radio>
                  <b-form-radio :value="false">خیر</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group
                label="حمایت ها:"
                v-if="proposal.initialIsSupported"
                :class="proposal.initialSupportedType ? 'done' : 'required'"
              >
                <b-form-select
                  class="myselect2"
                  id="first"
                  v-model="proposal.initialSupportedType"
                  :options="options"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="عنوان حمایت دریافتی"
                v-if="
                  proposal.initialSupportedType == 'other' &&
                  proposal.initialIsSupported
                "
                :class="proposal.initialOtherSupport ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.initialOtherSupport"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="توضیحات حمایت دریافتی:"
                v-if="proposal.initialIsSupported"
                :class="
                  proposal.initialSupportDescription ? 'done' : 'required'
                "
              >
                <b-form-textarea
                  trim
                  rows="6"
                  v-model="proposal.initialSupportDescription"
                >
                </b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات دوره(' + step1progress + '%)'" active>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات دوره</h4>
              </template>
              <b-form-group label="عنوان دوره به زبان فارسی">
                <b-form-input trim v-model="proposal.faSubject"> </b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.enSubject ? 'done' : 'required'"
                label="عنوان دوره به زبان انگلیسی"
              >
                <b-form-input
                  trim
                  type="text"
                  dir="ltr"
                  v-model="proposal.enSubject"
                  @keydown="nameKeydown($event)"
                ></b-form-input>
              </b-form-group>
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != notUniversity
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                    >دانشگاه محل اجرای دوره</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="proposal.universityId"
                    name="checkbox-1"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="
                      reactivity = !reactivity;
                      proposal.mehvarId = '';
                    "
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group>
                <Select2
                  v-model="proposal.universityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @change="removeMehvar()"
                  :disabled="proposal.universityId == notUniversity"
                ></Select2>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherUniversity"
                  v-show="proposal.universityId == notUniversity"
                  placeholder="نام دانشگاه مورد نظر"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور دوره (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="selectedMehvar == index ? 'info' : 'light'"
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar.text }}
                  </b-list-group-item>
                </b-list-group>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="proposal.mehvarId == notMehvar"
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="ماهیت دوره:"
                :class="
                  proposal.typeStudy ||
                  proposal.typeSystemicDevelopmental ||
                  proposal.typePractical
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox class="c-grey" v-model="proposal.typeStudy"
                  >مطالعاتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.typeSystemicDevelopmental"
                  >سیستمی و توسعه‌ای</b-form-checkbox
                >
                <b-form-checkbox class="c-grey" v-model="proposal.typePractical"
                  >کاربردی</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                label="حوزه دوره:"
                :class="
                  proposal.zoneMedicine ||
                  proposal.zoneAgriculture ||
                  proposal.zoneEnvironment ||
                  proposal.zoneIndustrial ||
                  proposal.zoneBioComputing ||
                  proposal.zoneOther
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox class="c-grey" v-model="proposal.zoneMedicine"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneEnvironment"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneIndustrial"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneBioComputing"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox class="c-grey" v-model="proposal.zoneOther"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات پژوهشگر(' + step2progress + '%)'">
            <b-card-body>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">اطلاعات پژوهشگر پسا دکتری</h4>
                </template>

                <b-card-text>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام"
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام خانوادگی"
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherLastName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="کدملی"
                        :class="
                          isIDClass(proposal.researcherNatCode)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherNatCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(proposal.researcherNatCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-row>
                        <b-col :cols="proposal.researcherMobile ? '12' : '10'">
                          <b-form-group
                            id="fieldset-horizontal"
                            :class="
                              proposal.researcherMobile ? 'done' : 'required'
                            "
                            description
                            label="تلفن همراه:"
                          >
                            <b-form-input
                              trim
                              disabled
                              v-model="proposal.researcherMobile"
                            ></b-form-input>
                            <b-row style="font-size: 12px" class="mt-1">
                              <i
                                class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                                aria-hidden="true"
                                style="font-size: 18px"
                              ></i>
                              <p class="text-danger ml-2">
                                شماره تلفن همراه شما قابل ویرایش نمی‌باشد
                              </p>
                            </b-row>
                          </b-form-group>
                        </b-col>
                        <b-col
                          v-if="!proposal.researcherMobile"
                          class="pt-1"
                          cols="2"
                        >
                          <b-button
                            class="mt-4"
                            variant="primary"
                            :disabled="gettingMobile"
                            @click="getMobile"
                            ><i class="fa fa-refresh" aria-hidden="true"></i
                          ></b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6"></div>
                  </div>

                  <b-form-group
                    label="پست الکترونیکی"
                    :class="
                      isEmailClass(proposal.researcherEmail)
                        ? 'done'
                        : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      :state="isEmail(proposal.researcherEmail)"
                      aria-describedby="input-1-live-feedback"
                      type="text"
                      v-model="proposal.researcherEmail"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback"
                      >پست الکترونیکی درست نیست</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <b-form-group
                    label="دورنگار"
                    :class="proposal.researcherFax ? 'done' : 'required'"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherFax"
                      type="number"
                      :no-wheel="true"
                    ></b-form-input>
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        id="fieldset-horizontal"
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                        description
                        label="استان:"
                      >
                        <!-- <b-form-input trim  v-model="executor.state"></b-form-input> -->
                        <v-autocomplete
                          v-model="proposal.researcherStateId"
                          :items="iran"
                          @change="
                            proposal.researcherCityId = '';
                            proposal.researcherState = iran.filter(
                              (x) => x.id == proposal.researcherStateId
                            )[0].name;
                          "
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                          class="dropdown-style"
                          hide-details
                        ></v-autocomplete>
                      </b-form-group> </b-col
                    ><b-col>
                      <b-form-group
                        id="fieldset-horizontal"
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                        description
                        label="شهر:"
                      >
                        <span v-show="false">{{ reactivity2 }}</span>
                        <v-autocomplete
                          v-model="proposal.researcherCityId"
                          :items="
                            iran
                              .filter((x) => x.id == proposal.researcherStateId)
                              .map((y) => y.cities)[0]
                          "
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                          class="dropdown-style"
                          hide-details
                          @change="
                            reactivity2 = !reactivity2;
                            proposal.researcherCity = iran
                              .filter(
                                (x) => x.id == proposal.researcherStateId
                              )[0]
                              .cities.filter(
                                (y) => y.id == proposal.researcherCityId
                              )[0].name;
                          "
                        ></v-autocomplete>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="universityClass">دانشگاه محل تحصیل</span>
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-2"
                        v-model="proposal.researcherUniversityId"
                        name="checkbox-2"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="proposal.researcherUniversityId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="
                        proposal.researcherUniversityId == notUniversity
                      "
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="proposal.researcherUniversityOther"
                      v-show="proposal.researcherUniversityId == notUniversity"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="رشته تحصیلی مقطع دکتری"
                    :class="proposal.researcherPhDField ? 'done' : 'required'"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherPhDField"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    :class="
                      proposal.researcherPhDThesisSubject ? 'done' : 'required'
                    "
                    label="عنوان رساله دکتری"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherPhDThesisSubject"
                      required
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        label="تاریخ دفاع"
                        :class="
                          proposal.researcherPhDThesisDefenceDate
                            ? 'done'
                            : 'required'
                        "
                      >
                        <date-picker
                          color="#7b1fa2"
                          v-model="proposal.researcherPhDThesisDefenceDate"
                        ></date-picker>
                      </b-form-group> </b-col
                    ><b-col>
                      <b-form-group
                        label="تاریخ دریافت مدرک دکتری"
                        :class="
                          proposal.researcherPhDCertificateDate
                            ? 'done'
                            : 'required'
                        "
                      >
                        <date-picker
                          color="#7b1fa2"
                          v-model="proposal.researcherPhDCertificateDate"
                        ></date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <i
                      class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                      aria-hidden="true"
                    ></i>
                    <p class="mt-2 ml-2">
                      تذکر: حداقل باید 3 سال از زمان فارغ التحصیلی متقاضی گذشته
                      باشد
                    </p>
                  </b-row>
                  <hr />
                  <b-row>
                    <i
                      class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                      aria-hidden="true"
                    ></i>
                    <p class="mt-2 ml-2">
                      تذکر: از گزینه‌های زیر یک مورد حتما باید انتخاب شود.
                    </p>
                  </b-row>
                  <br />
                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="proposal.researcherArticle"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6>
                          مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                  <b-row
                    v-if="proposal.researcherArticle"
                    class="border mb-2 pt-2"
                    align-v="center"
                  >
                    <i
                      class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                      aria-hidden="true"
                    ></i>
                    <p class="mt-2 ml-2 text-danger">
                      تذکر: مسئولیت بررسی و صحت DOI وارد شده بر عهده پژوهشگر
                      میباشد.
                      <br />
                      ممکن است برخی شناسه‌ها در سیستم تعریف نشده باشد؛ کافیست
                      پژوهشگر از صحت اطلاعات وارد شده مطمئن باشد.
                    </p>
                  </b-row>
                  <b-form-group
                    label="شناسه دیجیتالی مقاله (اول):"
                    v-if="proposal.researcherArticle"
                    :class="proposal.researcherDoi1 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="proposal.researcherDoi1"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col
                        ><b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(proposal.researcherDoi1, 0)"
                          :disabled="doiLoading[0]"
                        >
                          <b-spinner v-if="doiLoading[0]" small></b-spinner>
                          <span v-if="!doiLoading[0]">بررسی</span></b-button
                        >
                        <div v-show="false">
                          {{ check }}
                        </div>
                      </b-col></b-row
                    >
                  </b-form-group>
                  <b-form-group
                    label="شناسه دیجیتالی مقاله (دوم):"
                    v-if="proposal.researcherArticle"
                    :class="proposal.researcherDoi2 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="proposal.researcherDoi2"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col
                        ><b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(proposal.researcherDoi2, 1)"
                          :disabled="doiLoading[1]"
                        >
                          <b-spinner v-if="doiLoading[1]" small></b-spinner>
                          <span v-if="!doiLoading[1]">بررسی</span></b-button
                        >
                      </b-col>
                    </b-row>
                  </b-form-group>

                  <b-form-group
                    label="شناسه دیجیتالی مقاله (سوم):"
                    v-if="proposal.researcherArticle"
                    :class="proposal.researcherDoi3 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="proposal.researcherDoi3"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col
                        ><b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(proposal.researcherDoi3, 2)"
                          :disabled="doiLoading[2]"
                        >
                          <b-spinner v-if="doiLoading[2]" small></b-spinner>
                          <span v-if="!doiLoading[2]">بررسی</span></b-button
                        >
                      </b-col></b-row
                    >
                  </b-form-group>
                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="proposal.researcherInternationalPatent"
                      ></b-form-checkbox>
                      <label class="ml-2"><h6>ثبت اختراع بین‌المللی</h6></label>
                    </div>
                  </b-form-group>
                  <!-- researcher patent -->
                  <div v-if="proposal.researcherInternationalPatent">
                    <b-row>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <b-form-group
                          label="عنوان اختراع"
                          :class="
                            proposal.researcherInternationalPatentTitle
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-form-input
                            trim
                            v-model="
                              proposal.researcherInternationalPatentTitle
                            "
                          ></b-form-input> </b-form-group
                      ></b-col>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <b-form-group
                          label="سال اختراع"
                          :class="
                            proposal.researcherInternationalPatentYear
                              ? 'done'
                              : 'required'
                          "
                        >
                          <span v-show="false">{{ eduReactivity }}</span>
                          <b-form-input
                            trim
                            v-model="proposal.researcherInternationalPatentYear"
                            type="text"
                            rows="6"
                            max-rows="6"
                            @click="
                              showYearModal = true;
                              eduReactivity = !eduReactivity;
                            "
                            class="pointer"
                          ></b-form-input>
                          <year-modal
                            v-if="showYearModal"
                            :chosenYear="
                              proposal.researcherInternationalPatentYear
                            "
                            @dialogYear="getItemYear"
                            @showModal="getShowModal"
                          ></year-modal></b-form-group
                      ></b-col>
                    </b-row>
                    <b-row class="my-0 py-0">
                      <b-col cols="12">
                        <b-form-group
                          label="توضیحات اختراع"
                          :class="
                            proposal.researcherInternationalPatentDescription
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-textarea
                            v-model="
                              proposal.researcherInternationalPatentDescription
                            "
                          ></b-textarea> </b-form-group
                      ></b-col>
                    </b-row>
                    <!--<b-table
                      responsive
                      small
                      bordered
                      show-empty
                      head-variant="light"
                      :items="inventionItem"
                      :fields="inventionField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(subject)="data">
                        <b-form-input
                          trim
                          v-model="data.item.subject"
                          type="text"
                        ></b-form-input>
                      </template>
                      <template v-slot:cell(Iyear)="data">
                        <date-picker
                          color="#7b1fa2"
                          v-model="data.item.Iyear"
                          type="year"
                        ></date-picker>
                      </template>
                      <template v-slot:cell(description)="data">
                        <b-form-input
                          trim
                          v-model="data.item.description"
                          type="text"
                        ></b-form-input>
                      </template>
                    </b-table>-->
                  </div>
                </b-card-text>
              </b-card>
            </b-card-body>
          </b-tab>
          <b-tab
            :title="'اطلاعات مسئول دوره پسا دکتری(' + step3progress + '%)'"
          >
            <b-card-body>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">اطلاعات مسئول دوره پسا دکتری</h4>
                </template>

                <b-card-text>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام"
                        :class="supervisors[0].name ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="supervisors[0].name"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="نام خانوادگی"
                        :class="supervisors[0].lastName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="supervisors[0].lastName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="تلفن همراه"
                        :class="supervisors[0].mobile ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="number"
                          :no-wheel="true"
                          v-model="supervisors[0].mobile"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="کدملی"
                        :class="
                          isIDClass(supervisors[0].natCode)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="supervisors[0].natCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(supervisors[0].natCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <b-form-group
                        label="پست الکترونیکی"
                        :class="
                          isEmailClass(supervisors[0].email)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          :state="isEmail(supervisors[0].email)"
                          aria-describedby="input-1-live-feedback"
                          type="text"
                          v-model="supervisors[0].email"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >پست الکترونیکی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="سمت"
                        :class="supervisors[0].position ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          v-model="supervisors[0].position"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        :class="
                          supervisors[0].phdThesisSubject ? 'done' : 'required'
                        "
                        label="عنوان رساله دکتری"
                      >
                        <b-form-input
                          trim
                          v-model="supervisors[0].phdThesisSubject"
                          required
                        >
                        </b-form-input> </b-form-group
                    ></b-col>

                    <b-col>
                      <b-form-group
                        label="مرتبه علمی"
                        :class="
                          supervisors[0].academicRank ? 'done' : 'required'
                        "
                      >
                        <b-form-select
                          :options="colleaguePosition"
                          v-model="supervisors[0].academicRank"
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        label="نوع هیئت علمی"
                        :class="
                          supervisors[0].scienceCommitteeType
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-select
                          :options="committieType"
                          v-model="supervisors[0].scienceCommitteeType"
                        >
                        </b-form-select> </b-form-group
                    ></b-col>

                    <b-col>
                      <b-form-group
                        label="آخرین مدرک تحصیلی"
                        :class="supervisors[0].lastDegree ? 'done' : 'required'"
                      >
                        <b-form-select
                          :options="lastDegree"
                          v-model="supervisors[0].lastDegree"
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="supervisorUniversityClass"
                        >دانشگاه محل تحصیل
                      </span>
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-3"
                        v-model="supervisors[0].universityId"
                        name="checkbox-3"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="supervisors[0].universityId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="supervisors[0].universityId == notUniversity"
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="supervisors[0].universityOther"
                      v-show="supervisors[0].universityId == notUniversity"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="supervisorUniversityJobClass"
                        >دانشگاه محل اشتغال به عنوان عضوهئیت علمی</span
                      >
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-4"
                        v-model="supervisors[0].universityJobId"
                        name="checkbox-4"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="supervisors[0].universityJobId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="supervisors[0].universityJobId == 1"
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="supervisors[0].universityJobOther"
                      v-show="supervisors[0].universityJobId == 1"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="رزومه سوابق علمی، تخصصی و تحقیقاتی"
                    :class="supervisors[0].resumeFile ? 'done' : 'required'"
                  >
                    <b-form-file
                      :state="Boolean(supervisors[0].resumeFile)"
                      :disabled="Boolean(supervisors[0].resumeFile)"
                      @input="supUploadFile(supervisors[0].file, index)"
                      v-model="supervisors[0].file"
                      browse-text="بارگذاری"
                      :placeholder="
                        supervisors[0].resumeFile
                          ? supervisors[0].resumeFileName
                          : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                      "
                    ></b-form-file>
                  </b-form-group>
                  <b-form-group>
                    <b-col>
                      <b-progress
                        v-if="supervisors[0].showProgress"
                        :value="supervisors[0].uploadPercentage"
                        :max="max"
                        show-progress
                        :animated="supervisors[0].striped"
                        :variant="supervisors[0].variant"
                      ></b-progress>
                      <br />
                      <b-row>
                        <b-col>
                          <div
                            style="color: green"
                            v-if="supervisors[0].isUploaded"
                            color="green"
                          >
                            فایل جدید با موفقیت آپلود شد.
                          </div>
                        </b-col>
                        <b-col>
                          <b-row align-h="end" v-if="supervisors[0].resumeFile">
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success white--text"
                                :href="supervisors[0].resumeFile"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                            <b-button
                              style="height: 35px; float: left"
                              class="btn ml-2 mt-3"
                              variant="danger"
                              @click="
                                supervisors[0].file = null;
                                supervisors[0].resumeFile = '';
                                supervisors[0].resumeFileId = '';
                                supervisors[0].isUploaded = false;
                                supervisors[0].uploadPercentage = 0;
                              "
                              >حذف</b-button
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-form-group>

                  <hr />
                  <b-row>
                    <i
                      class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                      aria-hidden="true"
                    ></i>
                    <p class="mt-2 ml-2">
                      تذکر: از گزینه‌های زیر یک مورد حتما باید انتخاب شود.
                    </p>
                  </b-row>
                  <br />
                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="supervisors[0].article"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6>
                          مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                  <b-row
                    v-if="supervisors[0].article"
                    class="border mb-2 pt-2"
                    align-v="center"
                  >
                    <i
                      class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                      aria-hidden="true"
                    ></i>
                    <p class="mt-2 ml-2 text-danger">
                      تذکر: مسئولیت بررسی و صحت DOI وارد شده بر عهده پژوهشگر
                      میباشد.
                      <br />
                      ممکن است برخی شناسه‌ها در سیستم تعریف نشده باشد؛ کافیست
                      پژوهشگر از صحت اطلاعات وارد شده مطمئن باشد.
                    </p>
                  </b-row>
                  <b-form-group
                    label="شناسه دیجیتالی مقاله (اول):"
                    v-if="supervisors[0].article"
                    :class="supervisors[0].doi1 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          v-model="supervisors[0].doi1"
                          type="text"
                          dir="ltr"
                        >
                        </b-form-input> </b-col
                      ><b-col>
                        <b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(supervisors[0].doi1, 3)"
                          :disabled="doiLoading[3]"
                        >
                          <b-spinner v-if="doiLoading[3]" small></b-spinner>
                          <span v-if="!doiLoading[3]">بررسی</span></b-button
                        >
                      </b-col></b-row
                    >
                    <!-- <b-collapse id="collapse-4" class="mt-2">
                    <b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="DoiItem"
                      :fields="DoiField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                    </b-table>
                  </b-collapse> -->
                  </b-form-group>
                  <b-form-group
                    label="شناسه دیجیتالی مقاله (دوم):"
                    v-if="supervisors[0].article"
                    :class="supervisors[0].doi2 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="supervisors[0].doi2"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col>
                        <b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(supervisors[0].doi2, 4)"
                          :disabled="doiLoading[4]"
                        >
                          <b-spinner v-if="doiLoading[4]" small></b-spinner>
                          <span v-if="!doiLoading[4]">بررسی</span></b-button
                        >
                      </b-col></b-row
                    >
                    <!-- <b-collapse id="collapse-5" class="mt-2">
                    <b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="DoiItem"
                      :fields="DoiField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                    </b-table>
                  </b-collapse> -->
                  </b-form-group>

                  <b-form-group
                    label="شناسه دیجیتالی مقاله (سوم):"
                    v-if="supervisors[0].article"
                    :class="supervisors[0].doi3 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="supervisors[0].doi3"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col>
                        <b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(supervisors[0].doi3, 5)"
                          :disabled="doiLoading[5]"
                        >
                          <b-spinner v-if="doiLoading[5]" small></b-spinner>
                          <span v-if="!doiLoading[5]">بررسی</span></b-button
                        ></b-col
                      ></b-row
                    >
                    <!-- <b-collapse id="collapse-6" class="mt-2">
                    <b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="DoiItem"
                      :fields="DoiField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                    </b-table>
                  </b-collapse> -->
                  </b-form-group>

                  <b-form-group
                    label="شناسه دیجیتالی مقاله (چهارم):"
                    v-if="supervisors[0].article"
                    :class="supervisors[0].doi4 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="supervisors[0].doi4"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col
                        ><b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(supervisors[0].doi4, 6)"
                          :disabled="doiLoading[6]"
                        >
                          <b-spinner v-if="doiLoading[6]" small></b-spinner>
                          <span v-if="!doiLoading[6]">بررسی</span></b-button
                        ></b-col
                      ></b-row
                    >
                    <!-- <b-collapse id="collapse-7" class="mt-2">
                    <b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="DoiItem"
                      :fields="DoiField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                    </b-table>
                  </b-collapse> -->
                  </b-form-group>

                  <b-form-group
                    label="شناسه دیجیتالی مقاله (پنجم):"
                    v-if="supervisors[0].article"
                    :class="supervisors[0].doi5 ? 'done' : 'required'"
                    ><b-row
                      ><b-col cols="10">
                        <b-form-input
                          trim
                          dir="ltr"
                          v-model="supervisors[0].doi5"
                          type="text"
                        >
                        </b-form-input> </b-col
                      ><b-col
                        ><b-button
                          class="mr-5"
                          style="float: left"
                          @click="doiCheck(supervisors[0].doi5, 7)"
                          :disabled="doiLoading[7]"
                        >
                          <b-spinner v-if="doiLoading[7]" small></b-spinner>
                          <span v-if="!doiLoading[7]">بررسی</span></b-button
                        ></b-col
                      ></b-row
                    >
                    <!-- <b-collapse id="collapse-8" class="mt-2">
                    <b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="DoiItem"
                      :fields="DoiField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                    </b-table>
                  </b-collapse> -->
                  </b-form-group>

                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="supervisors[0].internationalPatent"
                      ></b-form-checkbox>
                      <label class="ml-2"><h6>ثبت اختراع بین‌المللی</h6></label>
                    </div>
                  </b-form-group>

                  <div v-if="supervisors[0].internationalPatent">
                    <b-row>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <b-form-group
                          label="عنوان اختراع"
                          :class="
                            supervisors[0].internationalPatentTitle
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-form-input
                            trim
                            v-model="supervisors[0].internationalPatentTitle"
                            type="text"
                          ></b-form-input> </b-form-group
                      ></b-col>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <b-form-group
                          label="سال اختراع"
                          :class="
                            supervisors[0].internationalPatentYear
                              ? 'done'
                              : 'required'
                          "
                        >
                          <span v-show="false">{{ eduReactivity }}</span>
                          <b-form-input
                            trim
                            v-model="supervisors[0].internationalPatentYear"
                            type="text"
                            rows="6"
                            max-rows="6"
                            @click="
                              showSupervisorYearModal = true;
                              eduReactivity = !eduReactivity;
                            "
                            class="pointer"
                          ></b-form-input>
                          <year-modal
                            v-if="showSupervisorYearModal"
                            :chosenYear="
                              supervisors[0].internationalPatentYear
                            "
                            @dialogYear="getSupervisorYear"
                            @showModal="getSupervisorShowModal"
                          ></year-modal></b-form-group
                      ></b-col>
                    </b-row>
                    <b-row class="my-0 py-0">
                      <b-col cols="12">
                        <b-form-group
                          label="توضیحات اختراع"
                          :class="
                            supervisors[0].internationalPatentDescription
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-textarea
                            v-model="
                              supervisors[0].internationalPatentDescription
                            "
                            type="text"
                          ></b-textarea></b-form-group
                      ></b-col>
                    </b-row>
                    <!--<b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="inventionItemMaster"
                      :fields="inventionFieldMaster"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(Msubject)="data">
                        <b-form-input
                          trim
                          v-model="data.item.Msubject"
                          type="text"
                        ></b-form-input>
                      </template>
                      <template v-slot:cell(Myear)="data">
                        <date-picker
                          color="#7b1fa2"
                          v-model="data.item.Myear"
                          type="year"
                        ></date-picker>
                      </template>
                      <template v-slot:cell(Mdescription)="data">
                        <b-form-input
                          trim
                          v-model="data.item.Mdescription"
                          type="text"
                        ></b-form-input>
                      </template>
                    </b-table>-->
                  </div>
                  <hr />
                  <b-form-group class="mt-2">
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="supervisors[0].researchFestivals"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6>اعضای برگزیده جشنواره های پژوهشی</h6></label
                      >

                      <b-col cols="7">
                        <b-form-group
                          class="ml-5"
                          label="عنوان جشنواره"
                          :class="
                            supervisors[0].researchFestivalsTitle
                              ? 'done'
                              : 'required'
                          "
                          v-if="supervisors[0].researchFestivals"
                        >
                          <b-form-input
                            trim
                            v-model="supervisors[0].researchFestivalsTitle"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </div>
                  </b-form-group>

                  <b-form-group class="mt-2">
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="supervisors[0].notSupervisor"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6
                          v-b-tooltip.hover
                          title="توجه فرمائید که در صورت انتخاب نیاز به بارگذاری معرفی نامه در قسمت فایل‌های تکمیلی دارید"
                        >
                          اگر استاد راهنمای متقاضی نیستید تیک را بزنید
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                </b-card-text>
              </b-card>
            </b-card-body>
          </b-tab>
          <b-tab :title="'مشخصات دوره(' + step4progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">مشخصات دوره</h4>
              </template>

              <b-form-group
                label="چکیده دوره (حداقل 100 کلمه)"
                :class="
                  proposal.abstract
                    ? proposal.abstract.split(' ').length < 100
                      ? 'required'
                      : 'done'
                    : 'required'
                "
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.abstract"
                  max-rows="6"
                ></b-form-textarea>
                طول چکیده:
                {{
                  proposal.abstract
                    ? (chek = proposal.abstract.split(" ").length)
                    : 0
                }}
                کلمه
              </b-form-group>
              <b-form-group
                label="ضرورت اجرای دوره"
                v-b-tooltip.hover.left
                title="در جهت دستیابی به اهداف ستاد و یا راهبردها و اقدامات سند توسعه زیست فناوری"
                :class="proposal.requestNecessity ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.requestNecessity"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="اهداف کلان دوره"
                :class="proposal.majorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.majorGoals"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="اهداف خرد دوره"
                :class="proposal.minorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.minorGoals"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="اجرای این دوره چه مزایای دیگری ممکن است برای کشور ایجاد کند؟"
                :class="proposal.benefitsToCountry ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.benefitsToCountry"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="روش شناسی (متدولوژی) و مراحل انجام دوره"
                :class="proposal.methodology ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.methodology"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="عنوان دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا خدمات) حاصل از اجرای دوره:"
                :class="achievmentClass"
              >
                <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addAchievment()"
                  >+</b-button
                >

                <!-- NOTE (t-proposal.requestProducts) to show achievment and output of proposal  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.requestProducts"
                  :fields="achievmentFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delAchievment(data.index)"
                      >x</b-button
                    >
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>

                  <template v-slot:cell(amount)="data">
                    <b-form-input
                      trim
                      v-model="data.item.amount"
                      type="number"
                      :no-wheel="true"
                      min="0"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(fullfill)="data">
                    <b-form-input
                      trim
                      v-model="data.item.fullfill"
                      type="number"
                      :no-wheel="true"
                      min="0"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-form-group>
              <b-form-group
                label="سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج از كشور (با ذكر ماخذ):"
                :class="proposal.executionHistorySimilar ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.executionHistorySimilar"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="آیا شركای بین‌المللی در اجرای طرح در نظر گرفته شده است؟ چه كسانی هستند و چه نقشی در مدیریت و اجرای دوره دارند؟"
                :class="proposal.internationalPartners ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.internationalPartners"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="منابع و ماخذ"
                :class="proposal.references ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.references"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="حمایتهای احتمالی قبلی ستاد از دوره:"
                :class="proposal.postDocLastSupports ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.postDocLastSupports"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="' اطلاعات تجاری‌سازی(' + step5progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات تجاری‌سازی</h4>
              </template>
              <v-row
                class="p-1 mb-4 grey lighten-2"
                style="border: 1px solid #ccc; border-radius: 10px"
              >
                <v-col>
                  <p>گزینه مورد نظر را انتخاب کنید:</p>
                  <b-form-radio-group
                    v-model="proposal.commercializingType"
                    class="d-flex justify-space-between"
                  >
                    <b-form-radio value="company" class="ms-1"
                      >شرکت دانش بنیان</b-form-radio
                    >
                    <b-form-radio value="accelerator">شتاب‌دهنده</b-form-radio>
                    <b-form-radio value="none">
                      فاقد اطلاعات تجاری‌سازی هستم</b-form-radio
                    >
                  </b-form-radio-group>
                </v-col>
              </v-row>

              <div v-if="proposal.commercializingType == 'company'">
                <div class="text-left mb-6">
                  <v-btn @click="viewList('company')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شرکت‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span
                      :class="
                        proposal.companyId
                          ? proposal.companyId != notCompany
                            ? 'done'
                            : proposal.otherCompanyName
                            ? 'done'
                            : 'required'
                          : 'required'
                      "
                    >
                      نام شرکت
                    </span>
                  </v-col>
                  <v-col class="text-left">
                    <b-form-checkbox
                      v-model="proposal.companyId"
                      :value="notCompany"
                      unchecked-value=""
                      @change="reactivity = !reactivity"
                    >
                      سایر شرکت ها
                    </b-form-checkbox>
                  </v-col>
                </v-row>
                <b-form-group>
                  <Select2
                    v-model="proposal.companyId"
                    :options="companies"
                    :settings="{ width: '100%' }"
                    :disabled="proposal.companyId == notCompany"
                    @change="getCompanyInfo()"
                  ></Select2>
                  <b-form-input
                    trim
                    class="mt-1"
                    v-model="proposal.otherCompanyName"
                    v-show="proposal.companyId == notCompany"
                    placeholder="نام شرکت"
                    @input="reactivity = !reactivity"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شماره ثبت شرکت"
                  :class="computedTitle1 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyRegistrationNumber
                        ? proposal.companyRegistrationNumber
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyRegistrationNumber"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شناسه ملی شرکت"
                  :class="computedTitle2 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyNationalId
                        ? proposal.companyNationalId
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyNationalId"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="معرفی فناوری یا محصولات شرکت:"
                  :class="proposal.companyProducts ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.companyProducts"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="آدرس پستی / شماره تماس/ پست الکترونیک شرکت:"
                  :class="proposal.companyContactInfo ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.companyContactInfo"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  :class="proposal.letterCompanyFile ? 'done' : 'required'"
                >
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه صنعت یا شرکت</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath + `/setad/private/1613290102342�*1�.doc`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :state="Boolean(proposal.letterCompanyFile)"
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(uploadedFiles[0].file, 0, 'letterCompanyFile')
                    "
                    v-model="uploadedFiles[0].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[0]
                        ? files[0].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>

                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="uploadedFiles[0].uploadPercentage"
                      :value="uploadedFiles[0].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[0].striped"
                      :variant="uploadedFiles[0].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[0].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row align-h="end" v-if="proposal.letterCompanyFile">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.letterCompanyFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(0, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div
                v-else-if="proposal.commercializingType == 'accelerator'"
                class="mb-4"
              >
                <div class="text-left mb-6">
                  <v-btn @click="viewList('accelerator')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شتاب‌دهنده‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span :class="proposal.acceleratorId ? 'done' : 'required'"
                      >نام شتاب‌دهنده</span
                    >
                  </v-col>
                </v-row>
                <Select2
                  v-model="proposal.acceleratorId"
                  :options="accelerators"
                  :settings="{ width: '100%' }"
                ></Select2>
                <b-form-group>
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه صنعت یا شرکت</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath + `/setad/private/1613290102342�*1�.doc`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(uploadedFiles[0].file, 0, 'letterCompanyFile')
                    "
                    v-model="uploadedFiles[0].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[0]
                        ? files[0].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>

                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="uploadedFiles[0].uploadPercentage"
                      :value="uploadedFiles[0].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[0].striped"
                      :variant="uploadedFiles[0].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[0].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row align-h="end" v-if="proposal.letterCompanyFile">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.letterCompanyFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(0, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div v-else-if="proposal.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation1 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation2 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
              <b-card
                header-bg-variant="default"
                class="border-0 shadow-sm mt-5"
              >
                <template v-slot:header>
                  <h4 class="mb-0">
                    ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                  </h4>
                </template>

                <b-form-group
                  label="نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق مالکیت:"
                  :class="
                    proposal.interactUniversityCenters ? 'done' : 'required'
                  "
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.interactUniversityCenters"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="معرفی بازار هدف:"
                  :class="proposal.targetMarket ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.targetMarket"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="پیش بینی میزان فروش محصول در سه سال اول:"
                  :class="proposal.productSalesForecast ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.productSalesForecast"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="میزان اشتغال زایی دوره:"
                  :class="proposal.employment ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.employment"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="برآورد مدت زمان همکاری:"
                  :class="proposal.durationCooperation ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.durationCooperation"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="برآورد میزان تولید و عایدی دوره:"
                  :class="
                    proposal.estimationProductionProjectRevenue
                      ? 'done'
                      : 'required'
                  "
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    max-rows="6"
                    v-model="proposal.estimationProductionProjectRevenue"
                  ></b-form-textarea>
                </b-form-group>

                <b-form-group
                  label="محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت وجود):"
                  :class="
                    proposal.competitiveProductsLevelCompetitiveness
                      ? 'done'
                      : 'required'
                  "
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    max-rows="6"
                    v-model="proposal.competitiveProductsLevelCompetitiveness"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="مزیت محصول نسبت به موارد مشابه و موجود:"
                  :class="proposal.productAdvantages ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    max-rows="6"
                    v-model="proposal.productAdvantages"
                  ></b-form-textarea>
                </b-form-group>
              </b-card>
            </b-card>
          </b-tab>
          <b-tab :title="'زمان‌بندی(' + step6progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">شرح خدمات، زمان‌بندی و فازبندی دوره</h4>
              </template>

              <b-form-group>
                <!-- NOTE (b-addService) to add a row to service items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addService()"
                  >+</b-button
                >

                <!-- NOTE (t-serviceItems) to show informations of phase scheduling, activities description and weight percentage of activity  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(report)="data">
                    <b-form-checkbox
                      :id="'tooltip-target-' + data.index"
                      v-model="data.item.report"
                    ></b-form-checkbox>
                    <b-tooltip
                      placement="top"
                      :show="myshow"
                      delay="100"
                      :target="'tooltip-target-' + data.index"
                      >درصورت ارائه گزارش در پایان این فاز به ستاد، انتخاب
                      نمایید</b-tooltip
                    >
                  </template>
                  <template v-slot:cell(cellColor)="data">
                    <div>
                      <ColourPicker
                        ref="colorPicker"
                        no-input
                        picker="compact"
                        :color="data.item.cellColor"
                        :value="data.item.cellColor"
                        v-model="data.item.cellColor"
                      />
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delService(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>

                  <template v-slot:cell(percent)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.percent"
                        type="number"
                        :no-wheel="true"
                        min="0"
                        max="100"
                        :state="
                          data.item.percent > 0 && data.item.percent <= 100
                        "
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.startDate"
                        @change="changedStartDate(data.item, data.index)"
                      ></date-picker>
                    </div>
                  </template>
                  <template v-slot:cell(dueDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.dueDate"
                        :min="computedMinDate(data.item.startDate)"
                      ></date-picker>
                    </div>
                  </template>
                </b-table>

                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />

                <p
                  :class="
                    proposal.gantData
                      .map((x) => x.percent)
                      .reduce((a, b) => Number(a) + Number(b), 0) == 100
                      ? 'done'
                      : 'required'
                  "
                >
                  توجه داشته باشید که مجموع درصد وزنی فعالیت باید 100 درصد باشد.
                  درصد فعلی:
                  {{
                    proposal.gantData.length == 0
                      ? 0
                      : proposal.gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }}
                  %
                </p>
              </b-form-group>
            </b-card>
          </b-tab>

          <b-tab :title="' هزینه‌ها(' + step7progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">هزینه‌های پرسنلی اعم از مجری و همكاران</h4>
              </template>

              <!-- NOTE (b-addCost) to add cost to costs table -->
              <b-button @click="addCost1()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-personnelCost) to show personnel costs with details about each personnel -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.personnelCosts"
                :fields="PersonnelCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delCost) to remove a row from costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delCost1(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(degree)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.degree"
                      :options="options1"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(cooperationType)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.cooperationType"
                      :options="options2"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(cooperationHour)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.cooperationHour"
                      type="number"
                      min="0"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(perPersonCost)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.perPersonCost"
                      type="number"
                      min="0"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(humanResourceCost)="data">
                  <div>
                    {{
                      (
                        parseInt(data.item.perPersonCost) *
                        parseInt(data.item.cooperationHour)
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              جمع کل هزینه های پرسنلی:
              {{
                proposal.personnelCosts.length == 0
                  ? 0
                  : proposal.personnelCosts
                      .map(
                        (x) =>
                          parseInt(x.perPersonCost) *
                          parseInt(x.cooperationHour)
                      )
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">
                  هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                  نقل، حق مأموریت و ...)
                </h4>
              </template>

              <!-- NOTE (b-addTripCost) to add a row to trip costs table -->
              <b-button @click="addTripCost()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-tripCost) to show trip costs with details about destination, purpose of trip,... -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.travelExpenses"
                :fields="tripCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delTripCost) to remove a row on trip costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delTripCost(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(destination)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.destination"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(reason)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.reason"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(number)="data">
                  <div>
                    <b-form-input
                      trim
                      min="0"
                      type="number"
                      v-model="data.item.number"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(day)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.day"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(cost)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.cost"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              جمع کل مسافرت‌های ضروری:
              {{
                proposal.travelExpenses.length == 0
                  ? 0
                  : proposal.travelExpenses
                      .map((x) => x.cost)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">
                  هزینه دستگاه‌ها، وسایل و مواد مورد نیاز كه باید از محل اعتبار
                  طرح خریداری شوند
                </h4>
              </template>

              <!-- NOTE (b-addDeviceCost) to add device cost to device costs table -->
              <b-button @click="addDeviceCost()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-deviceCost) to show the cost of devices with details about each device -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.purchases"
                :fields="deviceCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(type)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.type"
                      :options="deviceTypes"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delDeviceCost) to remove a row from device costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delDeviceCost(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(source)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.source"
                      :options="sources"
                      style="min-width: 100px"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(number)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.number"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(perPrice)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.perPrice"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">
                  <!-- <div>
                  <b-form-input trim  v-model="data.item.totalPrice" type="number"  :no-wheel='true'></b-form-input>
                </div>-->
                  <div>
                    {{
                      (
                        parseInt(data.item.number) *
                        parseInt(data.item.perPrice)
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              جمع کل هزینه دستگاه‌ها:
              {{
                proposal.purchases.length == 0
                  ? 0
                  : proposal.purchases
                      .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">میزان مشارکت سایر سازمان ها در بودجه طرح</h4>
              </template>

              <!-- NOTE (b-addOrgCost) to add organization cost to organization costs table -->
              <b-button @click="addOrgCost()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-orgCost) to show cost of cooperation with other organisations -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.participationOrganizationBudget"
                :fields="OrgCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary mb-2"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delOrgCost) to remove a row from organization costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delOrgCost(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(description)="data">
                  <div>
                    <b-form-textarea
                      trim
                      v-model="data.item.description"
                    ></b-form-textarea>
                  </div>
                </template>

                <template v-slot:cell(totalPrice)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.totalPrice"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              جمع کل مشارکت موسسات:
              {{
                proposal.participationOrganizationBudget.length == 0
                  ? 0
                  : proposal.participationOrganizationBudget
                      .map((x) => x.totalPrice)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3 mt-2"
                  aria-hidden="true"
                ></i>
                <p class="mt-3 ml-2">
                  اگر زیرساخت،تجهیزات و دستگاه مد نظر است مبلغ میزان مشارکت وارد
                  نشود ولی مراکزی که قرار است مشارکت کنند معرفی شوند.
                </p>
              </b-row>
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">هزینه‌های دیگر:</h4>
              </template>
              <!-- NOTE (t-otherCost) to show any other cost with three default row  -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.otherCosts"
                :fields="otherCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>

                <template v-slot:cell(totalPrice)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.totalPrice"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              <p>
                جمع کل سایر هزینه‌ها:
                {{
                  proposal.otherCosts.length == 0
                    ? 0
                    : proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </p>
            </b-card>
            <h3>
              جمع کل هزینه‌ها:
              {{
                (tPrice = (
                  (proposal.personnelCosts.length == 0
                    ? 0
                    : proposal.personnelCosts
                        .map(
                          (x) =>
                            parseInt(x.perPersonCost) *
                            parseInt(x.cooperationHour)
                        )
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.travelExpenses.length == 0
                    ? 0
                    : proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.purchases.length == 0
                    ? 0
                    : proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.otherCosts.length == 0
                    ? 0
                    : proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                ).toLocaleString())
              }}
              تومان
            </h3>
            <hr />
            <h3>
              میزان اعتبار مورد نیاز از ستاد زیست فناوری:
              {{ computedTotalCost.toLocaleString() }}
              تومان
            </h3>
          </b-tab>

          <b-tab :title="'فایل‌های تکمیلی(' + step8progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">فایل‌ها</h4>
              </template>
              <b-form-group
                :class="
                  proposal.letterUniversityResearchFile ? 'done' : 'required'
                "
              >
                <b-row class="mb-2" align-v="center">
                  <b-col align-self="end">
                    <h6>نامه شورای پژوهش یا فناوری دانشگاه</h6>
                  </b-col>
                  <b-col>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="
                        filePath +
                        `/setad/private/1613804042524pajoheshi_postDoc.doc`
                      "
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.letterUniversityResearchFile)"
                  :disabled="Boolean(proposal.letterUniversityResearchFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[1].file,
                      1,
                      'letterUniversityResearchFile'
                    )
                  "
                  v-model="uploadedFiles[1].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[1]
                      ? files[1].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[1].uploadPercentage"
                    :value="uploadedFiles[1].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[1].striped"
                    :variant="uploadedFiles[1].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[1].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        align-h="end"
                        v-if="proposal.letterUniversityResearchFile"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.letterUniversityResearchFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(1, 'letterUniversityResearchFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="توافقنامه دانشگاه با صنعت"
                :class="
                  proposal.universityAgreementIndustryFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.universityAgreementIndustryFile)"
                  :disabled="Boolean(proposal.universityAgreementIndustryFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[2].file,
                      2,
                      'universityAgreementIndustryFile'
                    )
                  "
                  v-model="uploadedFiles[2].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[2]
                      ? files[2].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[2].uploadPercentage"
                    :value="uploadedFiles[2].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[2].striped"
                    :variant="uploadedFiles[2].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[2].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        align-h="end"
                        v-if="proposal.universityAgreementIndustryFile"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.universityAgreementIndustryFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(2, 'universityAgreementIndustryFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="
                  proposal.letterUniversityAccountNumberFile
                    ? 'done'
                    : 'required'
                "
              >
                <b-row class="mb-2" align-v="center">
                  <b-col align-self="end">
                    <h6>نامه اعلام شماره حساب هزینه ای دانشگاه</h6>
                  </b-col>
                  <b-col>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="
                        filePath +
                        `/setad/private/1613803673406foramt_name_shomare_hesab.docx`
                      "
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.letterUniversityAccountNumberFile)"
                  :disabled="
                    Boolean(proposal.letterUniversityAccountNumberFile)
                  "
                  @input="
                    uploadFile(
                      uploadedFiles[3].file,
                      3,
                      'letterUniversityAccountNumberFile'
                    )
                  "
                  v-model="uploadedFiles[3].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[3]
                      ? files[3].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[3].uploadPercentage"
                    :value="uploadedFiles[3].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[3].striped"
                    :variant="uploadedFiles[3].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[3].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.letterUniversityAccountNumberFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.letterUniversityAccountNumberFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(3, 'letterUniversityAccountNumberFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="رزومه استاد راهنما (فارسی)"
                :class="
                  proposal.postDocTeacherResumeFaFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocTeacherResumeFaFile)"
                  :disabled="Boolean(proposal.postDocTeacherResumeFaFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[4].file,
                      4,
                      'postDocTeacherResumeFaFile'
                    )
                  "
                  v-model="uploadedFiles[4].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[4]
                      ? files[4].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[4].uploadPercentage"
                    :value="uploadedFiles[4].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[4].striped"
                    :variant="uploadedFiles[4].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[4].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocTeacherResumeFaFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocTeacherResumeFaFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(4, 'postDocTeacherResumeFaFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="رزومه استاد راهنما (انگلیسی)"
                :class="
                  proposal.postDocTeacherResumeEnFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocTeacherResumeEnFile)"
                  :disabled="Boolean(proposal.postDocTeacherResumeEnFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[5].file,
                      5,
                      'postDocTeacherResumeEnFile'
                    )
                  "
                  v-model="uploadedFiles[5].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[5]
                      ? files[5].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="Boolean(uploadedFiles[5].showProgress)"
                    :value="uploadedFiles[5].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[5].striped"
                    :variant="uploadedFiles[5].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[5].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocTeacherResumeEnFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocTeacherResumeEnFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(5, 'postDocTeacherResumeEnFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="رزومه متقاضی (فارسی)"
                :class="
                  proposal.postDocResearcherResumeFaFileIdFile
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocResearcherResumeFaFileIdFile)"
                  :disabled="
                    Boolean(proposal.postDocResearcherResumeFaFileIdFile)
                  "
                  @input="
                    uploadFile(
                      uploadedFiles[6].file,
                      6,
                      'postDocResearcherResumeFaFileIdFile'
                    )
                  "
                  v-model="uploadedFiles[6].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[6]
                      ? files[6].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[6].uploadPercentage"
                    :value="uploadedFiles[6].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[6].striped"
                    :variant="uploadedFiles[6].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[6].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocResearcherResumeFaFileIdFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocResearcherResumeFaFileIdFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(6, 'postDocResearcherResumeFaFileIdFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="رزومه متقاضی (انگلیسی)"
                :class="
                  proposal.postDocResearcherResumeEnFileIdFile
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocResearcherResumeEnFileIdFile)"
                  :disabled="
                    Boolean(proposal.postDocResearcherResumeEnFileIdFile)
                  "
                  @input="
                    uploadFile(
                      uploadedFiles[7].file,
                      7,
                      'postDocResearcherResumeEnFileIdFile'
                    )
                  "
                  v-model="uploadedFiles[7].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[7]
                      ? files[7].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[7].uploadPercentage"
                    :value="uploadedFiles[7].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[7].striped"
                    :variant="uploadedFiles[7].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[7].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocResearcherResumeEnFileIdFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocResearcherResumeEnFileIdFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(7, 'postDocResearcherResumeEnFileIdFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="حکم عضویت هیئت علمی استاد"
                :class="
                  proposal.postDocProfessorFacultyMembershipFile
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-file
                  :state="
                    Boolean(proposal.postDocProfessorFacultyMembershipFile)
                  "
                  :disabled="
                    Boolean(proposal.postDocProfessorFacultyMembershipFile)
                  "
                  @input="
                    uploadFile(
                      uploadedFiles[8].file,
                      8,
                      'postDocProfessorFacultyMembershipFile'
                    )
                  "
                  v-model="uploadedFiles[8].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[8]
                      ? files[8].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[8].uploadPercentage"
                    :value="uploadedFiles[8].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[8].striped"
                    :variant="uploadedFiles[8].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[8].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocProfessorFacultyMembershipFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="
                              proposal.postDocProfessorFacultyMembershipFile
                            "
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(8, 'postDocProfessorFacultyMembershipFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <h5 style="text-align: center; color: black">
                مقالات (ISI) ۳ سال اخیر
              </h5>
              <br />
              <b-form-group
                label="مقاله اول"
                :class="proposal.postDocArticle1File ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.postDocArticle1File)"
                  :disabled="Boolean(proposal.postDocArticle1File)"
                  @input="
                    uploadFile(uploadedFiles[9].file, 9, 'postDocArticle1File')
                  "
                  v-model="uploadedFiles[9].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[9]
                      ? files[9].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="Boolean(uploadedFiles[9].uploadPercentage)"
                    :value="uploadedFiles[9].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[9].striped"
                    :variant="uploadedFiles[9].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[9].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.postDocArticle1File" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocArticle1File"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(9, 'postDocArticle1File')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="مقاله دوم"
                :class="proposal.postDocArticle2File ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.postDocArticle2File)"
                  :disabled="Boolean(proposal.postDocArticle2File)"
                  @input="
                    uploadFile(
                      uploadedFiles[10].file,
                      10,
                      'postDocArticle2File'
                    )
                  "
                  v-model="uploadedFiles[10].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[10]
                      ? files[10].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[10].uploadPercentage"
                    :value="uploadedFiles[10].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[10].striped"
                    :variant="uploadedFiles[10].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[10].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.postDocArticle2File" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocArticle2File"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(10, 'postDocArticle2File')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="مقاله سوم"
                :class="proposal.postDocArticle3File ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.postDocArticle3File)"
                  :disabled="Boolean(proposal.postDocArticle3File)"
                  @input="
                    uploadFile(
                      uploadedFiles[11].file,
                      11,
                      'postDocArticle3File'
                    )
                  "
                  v-model="uploadedFiles[11].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[11]
                      ? files[11].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[11].uploadPercentage"
                    :value="uploadedFiles[11].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[11].striped"
                    :variant="uploadedFiles[11].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[11].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.postDocArticle3File" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocArticle3File"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(11, 'postDocArticle3File')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="مقاله چهارم"
                :class="proposal.postDocArticle4File ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.postDocArticle4File)"
                  :disabled="Boolean(proposal.postDocArticle4File)"
                  @input="
                    uploadFile(
                      uploadedFiles[12].file,
                      12,
                      'postDocArticle4File'
                    )
                  "
                  v-model="uploadedFiles[12].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[12]
                      ? files[12].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[12].uploadPercentage"
                    :value="uploadedFiles[12].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[12].striped"
                    :variant="uploadedFiles[12].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[12].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.postDocArticle4File" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocArticle4File"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(12, 'postDocArticle4File')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="مقاله پنجم"
                :class="proposal.postDocArticle5File ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.postDocArticle5File)"
                  :disabled="Boolean(proposal.postDocArticle5File)"
                  @input="
                    uploadFile(
                      uploadedFiles[13].file,
                      13,
                      'postDocArticle5File'
                    )
                  "
                  v-model="uploadedFiles[13].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[13]
                      ? files[13].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[13].uploadPercentage"
                    :value="uploadedFiles[13].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[13].striped"
                    :variant="uploadedFiles[13].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[13].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.postDocArticle5File" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocArticle5File"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(13, 'postDocArticle5File')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <hr />
              <b-form-group
                label="مدرک برگزیدگان جشنواره‌ها"
                :class="
                  proposal.postDocResearchFestivalFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocResearchFestivalFile)"
                  :disabled="Boolean(proposal.postDocResearchFestivalFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[14].file,
                      14,
                      'postDocResearchFestivalFile'
                    )
                  "
                  v-model="uploadedFiles[14].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[14]
                      ? files[14].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-row
                ><b-col cols="6">
                  <b-form-group
                    label="عنوان"
                    :class="
                      proposal.postDocResearchFestivalFileTitle
                        ? 'done'
                        : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.postDocResearchFestivalFileTitle"
                    ></b-form-input>
                  </b-form-group> </b-col
                ><b-col cols="6">
                  <b-form-group
                    label="توضیحات"
                    :class="
                      proposal.postDocResearchFestivalFileDescription
                        ? 'done'
                        : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.postDocResearchFestivalFileDescription"
                    ></b-form-input>
                  </b-form-group> </b-col
              ></b-row>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[14].uploadPercentage"
                    :value="uploadedFiles[14].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[14].striped"
                    :variant="uploadedFiles[14].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[14].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocResearchFestivalFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocResearchFestivalFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(14, 'postDocResearchFestivalFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="مستندات طرح های کاربردی"
                :class="
                  proposal.postDocApplicationDocumentationFile
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocApplicationDocumentationFile)"
                  :disabled="
                    Boolean(proposal.postDocApplicationDocumentationFile)
                  "
                  @input="
                    uploadFile(
                      uploadedFiles[15].file,
                      15,
                      'postDocApplicationDocumentationFile'
                    )
                  "
                  v-model="uploadedFiles[15].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[15]
                      ? files[15].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[15].uploadPercentage"
                    :value="uploadedFiles[15].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[15].striped"
                    :variant="uploadedFiles[15].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[15].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocApplicationDocumentationFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocApplicationDocumentationFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(15, 'postDocApplicationDocumentationFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="مدرک دکتری پژوهشگر"
                :class="
                  proposal.postDocPhDCertificateFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.postDocPhDCertificateFile)"
                  :disabled="Boolean(proposal.postDocPhDCertificateFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[16].file,
                      16,
                      'postDocPhDCertificateFile'
                    )
                  "
                  v-model="uploadedFiles[16].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[16]
                      ? files[16].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[16].uploadPercentage"
                    :value="uploadedFiles[16].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[16].striped"
                    :variant="uploadedFiles[16].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[16].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocPhDCertificateFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocPhDCertificateFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(16, 'postDocPhDCertificateFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                label="معرفی نامه"
                :class="
                  proposal.postDocIntroductionLetterFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  @input="
                    uploadFile(
                      uploadedFiles[17].file,
                      17,
                      'postDocIntroductionLetterFile'
                    )
                  "
                  :disabled="Boolean(proposal.postDocIntroductionLetterFile)"
                  :state="Boolean(proposal.postDocIntroductionLetterFile)"
                  v-model="uploadedFiles[17].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[17]
                      ? files[17].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[17].uploadPercentage"
                    :value="uploadedFiles[17].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[17].striped"
                    :variant="uploadedFiles[17].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[17].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.postDocIntroductionLetterFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.postDocIntroductionLetterFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(17, 'postDocIntroductionLetterFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <!-- NOTE (t-fileFields) to show uploded files and each file is downloadable  -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="fileFields"
                :items="files.filter((x) => x && x.url != '')"
                empty-text="فایلی برای نمایش وجود ندارد"
                empty-filtered-text="فایلی برای نمایش وجود ندارد"
                striped
                :busy="fileBusy"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(url)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                    <a
                      v-if="data.value"
                      class="btn btn-success white--text"
                      :href="data.value"
                      target="_blank"
                      >دریافت فایل</a
                    >
                  </div>
                </template>

                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات(' + step9progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <b-form-group>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                >
                  این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                  مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                >
                  این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                  انجام:
                  {{
                    (tPrice = (
                      (proposal.personnelCosts.length == 0
                        ? 0
                        : proposal.personnelCosts
                            .map(
                              (x) =>
                                parseInt(x.perPersonCost) *
                                parseInt(x.cooperationHour)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.travelExpenses.length == 0
                        ? 0
                        : proposal.travelExpenses
                            .map((x) => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.purchases.length == 0
                        ? 0
                        : proposal.purchases
                            .map(
                              (x) => parseInt(x.perPrice) * parseInt(x.number)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.otherCosts.length == 0
                        ? 0
                        : proposal.otherCosts
                            .map((x) => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                    ).toLocaleString())
                  }}
                  تومان
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                  می‌باشد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                  دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                >
                  بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                  بهره‌بردار:
                  {{ proposal.companyName }}
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                  می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت انجام
                  خواهد شد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[8]"
                  >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام طرح
                  به ستاد زیست فناوری ارسال و تحویل داده
                  می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[9]"
                  >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط مجری انجام و در
                  سایت بارگذاری می‌گردد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[10]"
                  >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[11]"
                  >سوابق پژوهشگر با موضوع دوره منطبق است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[12] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[12]"
                  >سوابق استاد راهنما با موضوع دوره منطبق است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[13] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[13]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    (proposal.researcherName ? proposal.researcherName : "-") +
                    " " +
                    proposal.researcherLastName
                  }}
                  به عنوان مجری طرح و همکاران می‌باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال(' + lastStepProgress + '%)'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    عنوان و حمایت‌های پیشین&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 0"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>

                      <li class="done">
                        <b
                          >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                          استفاده کرده است؟</b
                        >
                        <b-form-radio-group
                          v-model="proposal.initialIsSupported"
                          disabled
                        >
                          <b-form-radio :value="true">بله</b-form-radio>
                          <b-form-radio :value="false">خیر</b-form-radio>
                        </b-form-radio-group>
                      </li>

                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportedType ? 'done' : 'required'
                        "
                      >
                        <b>حمایت ها:</b>
                        {{
                          proposal.initialSupportedType
                            ? options.filter(
                                (x) => x.value == proposal.initialSupportedType
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.initialSupportedType == 'other'"
                        :class="
                          proposal.initialOtherSupport ? 'done' : 'required'
                        "
                      >
                        <b>عنوان حمایت دریافتی:</b>
                        {{ proposal.initialOtherSupport }}
                      </li>
                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportDescription
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b> توضیحات حمایت دریافتی:</b>
                        {{ proposal.initialSupportDescription }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-2 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات دوره&nbsp;({{ step1progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li :class="proposal.enSubject ? 'done' : 'required'">
                        <b>عنوان به زبان انگلیسی:</b> {{ proposal.enSubject }}
                      </li>
                      <li :class="proposal.universityId ? 'done' : 'required'">
                        <b>دانشگاه محل اجرای دوره:</b>
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar && mehvars.length"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور دوره:</b>
                        {{
                          proposal.mehvarId
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور دوره:</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.typeStudy ||
                          proposal.typeSystemicDevelopmental ||
                          proposal.typePractical
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>ماهیت دوره:</b>
                        <b-form-group
                          disabled
                          :class="
                            proposal.typeStudy ||
                            proposal.typeSystemicDevelopmental ||
                            proposal.typePractical
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-form-checkbox v-model="proposal.typeStudy"
                            >مطالعاتی</b-form-checkbox
                          >
                          <b-form-checkbox
                            v-model="proposal.typeSystemicDevelopmental"
                            >سیستمی و توسعه‌ای</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.typePractical"
                            >کاربردی</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه دوره:</b>
                        <b-form-group label="" disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات پژوهشگر&nbsp;({{ step2progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b>نام:</b> {{ proposal.researcherName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b>نام خانوادگی:</b> {{ proposal.researcherLastName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherNatCode ? 'done' : 'required'
                        "
                      >
                        <b> کدملی:</b> {{ proposal.researcherNatCode }}
                      </li>
                      <li
                        :class="proposal.researcherMobile ? 'done' : 'required'"
                      >
                        <b>تلفن همراه:</b> {{ proposal.researcherMobile }}
                      </li>
                      <li :class="proposal.researcherFax ? 'done' : 'required'">
                        <b>دورنگار:</b> {{ proposal.researcherFax }}
                      </li>
                      <li
                        :class="proposal.researcherEmail ? 'done' : 'required'"
                      >
                        <b> پست الکترونیکی:</b> {{ proposal.researcherEmail }}
                      </li>
                      <li
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                      >
                        <b> استان:</b>
                        {{
                          proposal.researcherState
                            ? proposal.researcherState
                            : "-"
                        }}
                      </li>
                      <li
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                      >
                        <b>شهر:</b>
                        {{
                          proposal.researcherCity
                            ? proposal.researcherCity
                            : "-"
                        }}
                      </li>
                      <li
                        :class="
                          proposal.researcherUniversityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          ).length
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityId == notUniversity"
                        :class="
                          proposal.researcherUniversityOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ proposal.researcherUniversityOther }}
                      </li>
                      <li
                        :class="
                          proposal.researcherPhDField ? 'done' : 'required'
                        "
                      >
                        <b>رشته تحصیلی مقطع دکتری:</b>
                        {{ proposal.researcherPhDField }}
                      </li>
                      <li
                        :class="
                          proposal.researcherPhDThesisSubject
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>عنوان رساله دکتری:</b>
                        {{ proposal.researcherPhDThesisSubject }}
                      </li>
                      <li
                        :class="
                          proposal.researcherPhDThesisDefenceDate
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>تاریخ دفاع مدرک دکتری:</b>
                        {{ proposal.researcherPhDThesisDefenceDate }}
                      </li>
                      <li
                        :class="
                          proposal.researcherPhDCertificateDate
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>تاریخ دریافت مدرک دکتری:</b>
                        {{ proposal.researcherPhDCertificateDate }}
                      </li>
                      <br />
                      <hr />

                      <b-form-group disabled>
                        <div class="d-flex" dir="rtl">
                          <b-form-checkbox
                            :value="true"
                            v-model="proposal.researcherArticle"
                          ></b-form-checkbox>
                          <label class="ml-2"
                            ><h6>
                              مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال
                              اخیر)
                            </h6></label
                          >
                        </div>
                      </b-form-group>
                      <div v-if="proposal.researcherArticle" class="p-2">
                        <li
                          :class="proposal.researcherDoi1 ? 'done' : 'required'"
                        >
                          <b>شناسه دیجیتالی مقاله (اول):</b>
                          {{ proposal.researcherDoi1 }}
                        </li>

                        <br />
                        <li
                          :class="proposal.researcherDoi2 ? 'done' : 'required'"
                        >
                          <b>شناسه دیجیتالی مقاله (دوم):</b>
                          {{ proposal.researcherDoi2 }}
                        </li>

                        <br />
                        <li
                          :class="proposal.researcherDoi3 ? 'done' : 'required'"
                        >
                          <b>شناسه دیجیتالی مقاله (سوم):</b>
                          {{ proposal.researcherDoi3 }}
                        </li>
                      </div>

                      <br />
                      <hr />
                      <b-form-group disabled>
                        <div class="d-flex" dir="rtl">
                          <b-form-checkbox
                            :value="true"
                            v-model="proposal.researcherInternationalPatent"
                          ></b-form-checkbox>
                          <label class="ml-2"
                            ><h6>ثبت اختراع بین‌المللی</h6></label
                          >
                        </div>
                      </b-form-group>

                      <div v-if="proposal.researcherInternationalPatent">
                        <b-row>
                          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <b
                              :class="
                                proposal.researcherInternationalPatentTitle
                                  ? 'done'
                                  : 'required'
                              "
                              >عنوان اختراع</b
                            >
                            <b-form-group>
                              <div class="readonly-box">
                                {{
                                  proposal.researcherInternationalPatentTitle
                                }}
                              </div>
                            </b-form-group></b-col
                          >
                          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <b
                              :class="
                                proposal.researcherInternationalPatentYear
                                  ? 'done'
                                  : 'required'
                              "
                              >سال اختراع</b
                            >
                            <b-form-group>
                              <div class="readonly-box">
                                {{ proposal.researcherInternationalPatentYear }}
                              </div>
                            </b-form-group></b-col
                          >
                        </b-row>
                        <b-row class="my-0 py-0">
                          <b-col cols="12" class="py-0">
                            <b
                              :class="
                                proposal.researcherInternationalPatentDescription
                                  ? 'done'
                                  : 'required'
                              "
                              >توضیحات اختراع</b
                            >
                            <b-form-group>
                              <div class="readonly-box">
                                {{
                                  proposal.researcherInternationalPatentDescription
                                }}
                              </div>
                            </b-form-group></b-col
                          >
                        </b-row>
                        <!--<b-table
                          responsive
                          small
                          show-empty
                          bordered
                          head-variant="light"
                          :items="inventionItem"
                          :fields="inventionField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(subject)="data">
                            <b-form-input
                              disabled
                              trim
                              v-model="data.item.subject"
                              type="text"
                            ></b-form-input>
                          </template>
                          <template v-slot:cell(Iyear)="data">
                            <b-form-input
                              disabled
                              color="#7b1fa2"
                              v-model="data.item.Iyear"
                            ></b-form-input>
                          </template>
                          <template v-slot:cell(description)="data">
                            <b-form-input
                              disabled
                              trim
                              v-model="data.item.description"
                              type="text"
                            ></b-form-input>
                          </template>
                        </b-table>-->
                      </div>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات مسئول دوره پسا دکتری&nbsp;({{ step3progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li :class="supervisors[0].name ? 'done' : 'required'">
                        <b>نام:</b> {{ supervisors[0].name }}
                      </li>
                      <li
                        :class="supervisors[0].lastName ? 'done' : 'required'"
                      >
                        <b> نام خانوادگی:</b> {{ supervisors[0].lastName }}
                      </li>
                      <li :class="supervisors[0].natCode ? 'done' : 'required'">
                        <b>کدملی:</b> {{ supervisors[0].natCode }}
                      </li>
                      <li :class="supervisors[0].mobile ? 'done' : 'required'">
                        <b>تلفن همراه:</b> {{ supervisors[0].mobile }}
                      </li>
                      <li :class="supervisors[0].email ? 'done' : 'required'">
                        <b> پست الکترونیکی:</b> {{ supervisors[0].email }}
                      </li>
                      <li
                        :class="supervisors[0].position ? 'done' : 'required'"
                      >
                        <b>سمت:</b> {{ supervisors[0].position }}
                      </li>
                      <li
                        :class="
                          supervisors[0].universityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          universities.filter(
                            (x) => x.id == supervisors[0].universityId
                          ).length
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="supervisors[0].universityId == notUniversity"
                        :class="
                          supervisors[0].universityOther ? 'done' : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b> {{ supervisors[0].universityOther }}
                      </li>
                      <li
                        :class="
                          supervisors[0].universityJobId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل اشتغال:</b>
                        {{
                          supervisors[0].universityJobId
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityJobId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="supervisors[0].universityJobId == notUniversity"
                        :class="
                          supervisors[0].universityJobOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ supervisors[0].universityJobOther }}
                      </li>
                      <li
                        :class="
                          supervisors[0].scienceCommitteeType
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نوع هیئت علمی:</b>
                        {{ supervisors[0].scienceCommitteeType }}
                      </li>
                      <li
                        :class="supervisors[0].lastDegree ? 'done' : 'required'"
                      >
                        <b>آخرین مدرک تحصیلی:</b>
                        {{ supervisors[0].lastDegree }}
                      </li>
                      <li
                        :class="
                          supervisors[0].phdThesisSubject ? 'done' : 'required'
                        "
                      >
                        <b>عنوان رساله دکتری:</b>
                        {{ supervisors[0].phdThesisSubject }}
                      </li>
                      <li
                        :class="
                          supervisors[0].academicRank ? 'done' : 'required'
                        "
                      >
                        <b>مرتبه علمی:</b> {{ supervisors[0].academicRank }}
                      </li>
                    </ul>
                    <hr />
                    <b-form-group disabled>
                      <div class="d-flex" dir="rtl">
                        <b-form-checkbox
                          :value="true"
                          v-model="supervisors[0].article"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6>
                            مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                          </h6></label
                        >
                      </div>
                    </b-form-group>
                    <div v-if="supervisors[0].article">
                      <li :class="supervisors[0].doi1 ? 'done' : 'required'">
                        <b>شناسه دیجیتالی مقاله (اول):</b>
                        {{ supervisors[0].doi1 }}
                      </li>

                      <br />
                      <li :class="supervisors[0].doi2 ? 'done' : 'required'">
                        <b>شناسه دیجیتالی مقاله (دوم):</b>
                        {{ supervisors[0].doi2 }}
                      </li>

                      <br />
                      <li :class="supervisors[0].doi3 ? 'done' : 'required'">
                        <b>شناسه دیجیتالی مقاله (سوم):</b>
                        {{ supervisors[0].doi3 }}
                      </li>

                      <br />
                      <li :class="supervisors[0].doi4 ? 'done' : 'required'">
                        <b>شناسه دیجیتالی مقاله (چهارم):</b>
                        {{ supervisors[0].doi4 }}
                      </li>

                      <br />
                      <li :class="supervisors[0].doi5 ? 'done' : 'required'">
                        <b>شناسه دیجیتالی مقاله (پنجم):</b>
                        {{ supervisors[0].doi5 }}
                      </li>
                    </div>
                    <br />
                    <hr />
                    <b-form-group disabled>
                      <div class="d-flex" dir="rtl">
                        <b-form-checkbox
                          :value="true"
                          v-model="supervisors[0].internationalPatent"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6>ثبت اختراع بین‌المللی</h6></label
                        >
                      </div>
                    </b-form-group>

                    <div v-if="supervisors[0].internationalPatent">
                      <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b
                            :class="
                              supervisors[0].internationalPatentTitle
                                ? 'done'
                                : 'required'
                            "
                            >عنوان اختراع</b
                          >
                          <b-form-group>
                            <div class="readonly-box">
                              {{ supervisors[0].internationalPatentTitle }}
                            </div>
                          </b-form-group></b-col
                        >
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b
                            :class="
                              supervisors[0].internationalPatentYear
                                ? 'done'
                                : 'required'
                            "
                            >سال اختراع</b
                          >
                          <b-form-group>
                            <div class="readonly-box">
                              {{ supervisors[0].internationalPatentYear }}
                            </div></b-form-group
                          ></b-col
                        >
                      </b-row>
                      <b-row class="my-0 py-0">
                        <b-col cols="12" class="py-0">
                          <b
                            :class="
                              supervisors[0].internationalPatentDescription
                                ? 'done'
                                : 'required'
                            "
                            >توضیحات اختراع</b
                          >
                          <b-form-group>
                            <div class="readonly-box">
                              {{
                                supervisors[0].internationalPatentDescription
                              }}
                            </div></b-form-group
                          ></b-col
                        >
                      </b-row>
                      <hr />
                      <!--<b-table
                        responsive
                        small
                        show-empty
                        bordered
                        head-variant="light"
                        :items="inventionItemMaster"
                        :fields="inventionFieldMaster"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(Msubject)="data">
                          <b-form-input
                            disabled
                            trim
                            v-model="data.item.Msubject"
                            type="text"
                          ></b-form-input>
                        </template>
                        <template v-slot:cell(Myear)="data">
                          <b-form-input
                            disabled
                            color="#7b1fa2"
                            v-model="data.item.Myear"
                          ></b-form-input>
                        </template>
                        <template v-slot:cell(Mdescription)="data">
                          <b-form-input
                            disabled
                            trim
                            v-model="data.item.Mdescription"
                            type="text"
                          ></b-form-input>
                        </template>
                      </b-table>-->
                    </div>
                    <br />
                    <b-form-group disabled class="mt-2">
                      <div class="d-flex" dir="rtl">
                        <b-form-checkbox
                          :value="true"
                          v-model="supervisors[0].researchFestivals"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6>اعضای برگزیده جشنواره های پژوهشی</h6></label
                        >
                      </div>
                    </b-form-group>
                    <li
                      v-if="supervisors[0].researchFestivals"
                      :class="
                        supervisors[0].researchFestivalsTitle
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>عنوان جشنواره:</b>
                      {{ supervisors[0].researchFestivalsTitle }}
                    </li>
                    <br />
                    <b-form-group class="mt-2" disabled>
                      <div class="d-flex" dir="rtl">
                        <b-form-checkbox
                          :value="true"
                          v-model="supervisors[0].notSupervisor"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6>
                            اگر استاد راهنمای متقاضی نیستید تیک را بزنید
                          </h6></label
                        >
                      </div>
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    مشخصات دوره&nbsp;({{ step4progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li
                        :class="proposal.abstract ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>چکیده دوره:</b> {{ proposal.abstract }}
                      </li>
                      <li
                        :class="proposal.requestNecessity ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b
                          >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                          راهبردها و اقدامات سند توسعه زیست فناوری):</b
                        >
                        {{ proposal.requestNecessity }}
                      </li>
                      <li
                        :class="proposal.majorGoals ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>اهداف کلان دوره:</b>{{ proposal.majorGoals }}
                      </li>
                      <li
                        :class="proposal.minorGoals ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>اهداف خرد دوره:</b>{{ proposal.minorGoals }}
                      </li>
                      <li
                        :class="
                          proposal.benefitsToCountry ? 'done' : 'required'
                        "
                        class="my-2"
                      >
                        <b> مزایای دیگر برای کشور:</b>
                        {{ proposal.benefitsToCountry }}
                      </li>
                      <li
                        :class="proposal.methodology ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b> روش شناسی (متدولوژی) و مراحل انجام دوره:</b>
                        {{ proposal.methodology }}
                      </li>
                      <li
                        :class="
                          proposal.requestProducts.length > 0
                            ? 'done'
                            : 'required'
                        "
                        class="my-2"
                        v-if="proposal.requestProducts.length > 0"
                      >
                        <b>
                          دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                          خدمات) حاصل از اجرای دوره:</b
                        >
                        <!-- NOTE (t-proposal.requestProducts-2) previous -->
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="proposal.requestProducts"
                          :fields="achievmentFields"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary my-3"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>
                      </li>
                      <li
                        :class="
                          proposal.executionHistorySimilar ? 'done' : 'required'
                        "
                        class="my-2"
                      >
                        <b
                          >سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج از
                          كشور (با ذكر ماخذ):</b
                        >
                        {{ proposal.executionHistorySimilar }}
                      </li>
                      <li
                        :class="
                          proposal.internationalPartners ? 'done' : 'required'
                        "
                        class="my-2"
                      >
                        <b>شركای بین‌المللی در اجرای دوره :</b>
                        {{ proposal.internationalPartners }}
                      </li>
                      <li
                        :class="proposal.references ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>منابع و ماخذ:</b> {{ proposal.references }}
                      </li>
                      <li
                        :class="
                          proposal.postDocLastSupports ? 'done' : 'required'
                        "
                        class="my-2"
                      >
                        <b>حمایتهای احتمالی قبلی ستاد از دوره:</b>
                        {{ proposal.postDocLastSupports }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    اطلاعات تجاری‌سازی&nbsp;({{ step5progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <div v-if="proposal.commercializingType == 'company'">
                      <ul class="p-2">
                        <div v-if="proposal.companyId == notCompany">
                          <li
                            :class="
                              proposal.otherCompanyName ? 'done' : 'required'
                            "
                            class="my-2"
                          >
                            <b>نام شرکت دانش بنیان:</b>
                            {{ proposal.otherCompanyName }}
                          </li>
                          <li
                            :class="
                              proposal.otherCompanyRegistrationNumber
                                ? 'done'
                                : 'required'
                            "
                            class="my-2"
                          >
                            <b>شماره ثبت شرکت:</b>
                            {{ proposal.otherCompanyRegistrationNumber }}
                          </li>
                          <li
                            :class="
                              proposal.otherCompanyNationalId
                                ? 'done'
                                : 'required'
                            "
                            class="my-2"
                          >
                            <b>شناسه ملی شرکت:</b>
                            {{ proposal.otherCompanyNationalId }}
                          </li>
                        </div>
                        <div v-else>
                          <li
                            :class="proposal.companyName ? 'done' : 'required'"
                            class="my-2"
                          >
                            <b>نام شرکت دانش بنیان:</b>
                            {{ proposal.companyName }}
                          </li>
                          <li class="my-2 done">
                            <b>شماره ثبت شرکت:</b>
                            {{
                              proposal.companyRegistrationNumber
                                ? proposal.companyRegistrationNumber
                                : "-"
                            }}
                          </li>
                          <li class="my-2 done">
                            <b>شناسه ملی شرکت:</b>
                            {{
                              proposal.companyNationalId
                                ? proposal.companyNationalId
                                : "-"
                            }}
                          </li>
                        </div>
                        <li
                          :class="
                            proposal.companyProducts ? 'done' : 'required'
                          "
                          class="my-2"
                        >
                          <b> معرفی فناوری یا محصولات شرکت:</b>
                          {{ proposal.companyProducts }}
                        </li>
                        <li
                          :class="
                            proposal.companyContactInfo ? 'done' : 'required'
                          "
                          class="my-2"
                        >
                          <b>آدرس پستی / شماره تماس/ پست الکترونیک شرکت:</b>
                          {{ proposal.companyContactInfo }}
                        </li>
                      </ul>
                    </div>
                    <ul
                      v-else-if="proposal.commercializingType == 'accelerator'"
                    >
                      <li>
                        <span
                          :class="proposal.acceleratorId ? 'done' : 'required'"
                          >نام شتاب‌دهنده:</span
                        >

                        {{
                          proposal.acceleratorId
                            ? accelerators.filter(
                                (x) => x.id == proposal.acceleratorId
                              )[0].text
                            : ""
                        }}
                      </li>
                    </ul>
                    <div v-else-if="proposal.commercializingType == 'none'">
                      <div class="d-flex flex-row mb-2">
                        <b-form-checkbox
                          disabled
                          v-model="proposal.commercializingObligation1"
                          @change="reactivity = !reactivity"
                        ></b-form-checkbox
                        ><span class="ps-2">
                          تایید میکنم با انتخاب این گزینه تا قبل از تایید
                          درخواست توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز،
                          ستاد توسعه زیست فناوری هیچگونه مسئولیتی در قبال
                          درخواست من نخواهد داشت.
                        </span>
                      </div>
                      <div class="d-flex flex-row mb-2">
                        <b-form-checkbox
                          disabled
                          v-model="proposal.commercializingObligation2"
                          @change="reactivity = !reactivity"
                        ></b-form-checkbox>
                        <span class="ps-2">
                          تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و
                          علمی این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های
                          مجاز قرار خواهد گرفت تا بتوانند با بررسی اطلاعات،
                          درخواست بنده را بررسی و تایید کنند.
                        </span>
                      </div>
                    </div>

                    <h5 class="text-primary mt-4">
                      ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                    </h5>
                    <ul class="p-2">
                      <li
                        :class="
                          proposal.interactUniversityCenters
                            ? 'done'
                            : 'required'
                        "
                        class="my-2"
                      >
                        <b>
                          نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                          مالکیت:</b
                        >
                        {{ proposal.interactUniversityCenters }}
                      </li>
                      <li
                        :class="proposal.targetMarket ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>معرفی بازار هدف:</b> {{ proposal.targetMarket }}
                      </li>
                      <li
                        :class="
                          proposal.productSalesForecast ? 'done' : 'required'
                        "
                        class="my-2"
                      >
                        <b>پیش بینی میزان فروش محصول در سه سال اول:</b>
                        {{ proposal.productSalesForecast }}
                      </li>
                      <li
                        :class="proposal.employment ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>میزان اشتغال زایی دوره:</b> {{ proposal.employment }}
                      </li>
                      <li
                        :class="
                          proposal.durationCooperation ? 'done' : 'required'
                        "
                      >
                        <b>برآورد مدت زمان همکاری:</b>
                        {{ proposal.durationCooperation }}
                      </li>
                      <li
                        :class="
                          proposal.estimationProductionProjectRevenue
                            ? 'done'
                            : 'required'
                        "
                        class="my-2"
                      >
                        <b>برآورد میزان تولید و عایدی دوره:</b>
                        {{ proposal.estimationProductionProjectRevenue }}
                      </li>
                      <li
                        :class="
                          proposal.competitiveProductsLevelCompetitiveness
                            ? 'done'
                            : 'required'
                        "
                        class="my-2"
                      >
                        <b>
                          محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت
                          وجود):</b
                        >
                        {{ proposal.competitiveProductsLevelCompetitiveness }}
                      </li>
                      <li
                        :class="
                          proposal.productAdvantages ? 'done' : 'required'
                        "
                        class="my-2"
                      >
                        <b>مزیت محصول نسبت به موارد مشابه و موجود:</b>
                        {{ proposal.productAdvantages }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    زمان‌بندی دوره&nbsp;({{ step6progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="p-3 shadow">
                    <b>زمان شروع:</b>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    <b>زمان پایان:</b>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    <b> مدت زمان:</b>
                    {{
                      proposal.gantData.length > 0
                        ? (Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          ) -
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )) /
                            3600 /
                            24 /
                            1000 +
                          " روز"
                        : ""
                    }}
                    <br />
                    <div>
                      <sarmadGantt
                        v-if="show"
                        :items="proposal.gantData"
                        :fields="serviceFields"
                      />
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-8 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    هزینه‌ها&nbsp;({{ step7progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 7"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-8"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <div v-if="proposal.personnelCosts.length > 0">
                      <hr />
                      <h5 class="mt-5 mb-3 text-primary">
                        هزینه‌های پرسنلی اعم از مجری و همكاران
                      </h5>

                      <!-- NOTE (t-personnelCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.personnelCosts"
                        :fields="PersonnelCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary mb-4"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                        <template v-slot:cell(humanResourceCost)="data">
                          <div>
                            {{
                              (
                                parseInt(data.item.perPersonCost) *
                                parseInt(data.item.cooperationHour)
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                      </b-table>
                      <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                      <p>
                        جمع کل هزینه های پرسنلی:
                        {{
                          proposal.personnelCosts.length == 0
                            ? 0
                            : proposal.personnelCosts
                                .map(
                                  (x) =>
                                    parseInt(x.perPersonCost) *
                                    parseInt(x.cooperationHour)
                                )
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                                .toLocaleString()
                        }}
                        تومان
                      </p>
                    </div>

                    <div v-if="proposal.travelExpenses.length > 0">
                      <h5 class="mt-5 mb-3 text-primary">
                        هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا،
                        حمل و نقل، حق مأموریت و ...):
                      </h5>

                      <!-- NOTE (t-tripCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.travelExpenses"
                        :fields="tripCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary mb-4"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                      جمع کل مسافرتهای ضروری:
                      {{
                        proposal.travelExpenses.length == 0
                          ? 0
                          : proposal.travelExpenses
                              .map((x) => x.cost)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                    </div>
                    <div v-if="proposal.purchases.length > 0">
                      <h5 class="mt-5 mb-3 text-primary">
                        هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل
                        اعتبار طرح خریداری شوند:
                      </h5>

                      <!-- NOTE (t-deviceCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.purchases"
                        :fields="deviceCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                        <template v-slot:cell(totalPrice)="data">
                          <div>
                            {{
                              (
                                parseInt(data.item.number) *
                                parseInt(data.item.perPrice)
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                      </b-table>
                      جمع کل هزینه دستگاه‌ها:
                      {{
                        proposal.purchases.length == 0
                          ? 0
                          : proposal.purchases
                              .map(
                                (x) => parseInt(x.perPrice) * parseInt(x.number)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                      <hr />
                    </div>

                    <div
                      v-if="proposal.participationOrganizationBudget.length > 0"
                    >
                      <h5 class="mt-5 mb-3 text-primary">
                        میزان مشارکت سایر موسسات:
                      </h5>

                      <!-- NOTE (t-orgCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.participationOrganizationBudget"
                        :fields="OrgCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                      جمع کل مشارکت موسسات:
                      {{
                        proposal.participationOrganizationBudget.length == 0
                          ? 0
                          : proposal.participationOrganizationBudget
                              .map((x) => x.totalPrice)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                    </div>
                    <div
                      v-show="
                        proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                      "
                    >
                      <h5 class="mt-5 mb-3 text-primary">هزینه‌های دیگر:</h5>

                      <!-- NOTE (t-otherCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.otherCosts"
                        :fields="otherCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                      <p>
                        جمع کل سایر هزینه‌ها:
                        {{
                          proposal.otherCosts.length == 0
                            ? 0
                            : proposal.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                                .toLocaleString()
                        }}
                        تومان
                      </p>
                    </div>
                    <h3>
                      جمع کل هزینه‌ها:
                      {{
                        (tPrice = (
                          (proposal.personnelCosts.length == 0
                            ? 0
                            : proposal.personnelCosts
                                .map(
                                  (x) =>
                                    parseInt(x.perPersonCost) *
                                    parseInt(x.cooperationHour)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.travelExpenses.length == 0
                            ? 0
                            : proposal.travelExpenses
                                .map((x) => x.cost)
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.purchases.length == 0
                            ? 0
                            : proposal.purchases
                                .map(
                                  (x) =>
                                    parseInt(x.perPrice) * parseInt(x.number)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.otherCosts.length == 0
                            ? 0
                            : proposal.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                        ).toLocaleString())
                      }}
                      تومان
                    </h3>
                    <hr />
                    <h3>
                      میزان اعتبار مورد نیاز از ستاد زیست فناوری:
                      {{ computedTotalCost.toLocaleString() }}
                      تومان
                    </h3>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-9 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    فایل‌های تکمیلی&nbsp;({{ step8progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 8"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-9"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h5>
                      در این جدول کلیه فایل‌های درخواست را مشاهده میفرمایید.
                    </h5>
                    <b-table
                      responsive
                      show-empty
                      head-variant="dark"
                      :fields="fileFields"
                      :items="files.filter((x) => x && x.url != '')"
                      empty-text="فایلی برای نمایش وجود ندارد"
                      empty-filtered-text="فایلی برای نمایش وجود ندارد"
                      striped
                      :busy="fileBusy"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>

                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(url)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                          <a
                            v-if="data.value"
                            class="btn btn-success"
                            :href="data.value"
                            target="_blank"
                            >دریافت فایل</a
                          >
                        </div>
                      </template>

                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-10 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    تعهدات&nbsp;({{ step9progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 9"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-10"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[0]"
                      >
                        این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد
                        و مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت
                        زمان:
                        {{
                          proposal.gantData.length > 0
                            ? (Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              ) -
                                Math.min(
                                  ...proposal.gantData.map((x) =>
                                    new Date(
                                      moment(
                                        x.startDate,
                                        "jYYYY/jMM/jDD"
                                      ).format("YYYY-MM-DD")
                                    ).getTime()
                                  )
                                )) /
                                3600 /
                                24 /
                                1000 +
                              " روز"
                            : ""
                        }}
                      </b-form-checkbox>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[1]"
                      >
                        این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد.
                        هزینه انجام:
                        {{
                          (tPrice = (
                            (proposal.personnelCosts.length == 0
                              ? 0
                              : proposal.personnelCosts
                                  .map(
                                    (x) =>
                                      parseInt(x.perPersonCost) *
                                      parseInt(x.cooperationHour)
                                  )
                                  .reduce(
                                    (a, b) => parseInt(a) + parseInt(b),
                                    0
                                  )) +
                            (proposal.travelExpenses.length == 0
                              ? 0
                              : proposal.travelExpenses
                                  .map((x) => x.cost)
                                  .reduce(
                                    (a, b) => parseInt(a) + parseInt(b),
                                    0
                                  )) +
                            (proposal.purchases.length == 0
                              ? 0
                              : proposal.purchases
                                  .map(
                                    (x) =>
                                      parseInt(x.perPrice) * parseInt(x.number)
                                  )
                                  .reduce(
                                    (a, b) => parseInt(a) + parseInt(b),
                                    0
                                  )) +
                            (proposal.otherCosts.length == 0
                              ? 0
                              : proposal.otherCosts
                                  .map((x) => x.totalPrice)
                                  .reduce(
                                    (a, b) => parseInt(a) + parseInt(b),
                                    0
                                  ))
                          ).toLocaleString())
                        }}
                        تومان
                      </b-form-checkbox>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[2]"
                        >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست
                        فناوری می‌باشد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[3]"
                        >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                        دارد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[4]"
                        >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[5]"
                      >
                        بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است.
                        نام بهره‌بردار:
                        {{
                          (proposal.researcherName
                            ? proposal.researcherName
                            : "-") +
                          " " +
                          (proposal.researcherLastName
                            ? proposal.researcherLastName
                            : "")
                        }}
                      </b-form-checkbox>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[6]"
                        >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                        می‌شود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[7]"
                        >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت
                        انجام خواهد شد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[8]"
                        >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان
                        انجام طرح به ستاد زیست فناوری ارسال و تحویل داده
                        می‌شود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[9]"
                        >کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام و
                        در سایت بارگذاری می‌گردد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[10] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[10]"
                        >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد
                        نمی‌کند و به منزله ثبت درخواست متقاضی
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[11] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[11]"
                        >سوابق پژوهشگر با موضوع دوره منطبق است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[12] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[12]"
                        >سوابق استاد راهنما با موضوع دوره منطبق
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[13] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[13]"
                        >کلیه موارد فوق مورد تایید اینجانب
                        {{
                          (proposal.researcherName
                            ? proposal.researcherName
                            : "-") +
                          " " +
                          (proposal.researcherLastName
                            ? proposal.researcherLastName
                            : "")
                        }}
                        به عنوان مجری طرح و همکاران می‌باشد.</b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-button
              :disabled="lastStepProgress != 100"
              class="m-2"
              variant="success"
              @click="submit()"
              >ارسال</b-button
            >
            <p v-if="lastStepProgress != 100" class="required">
              به منظور ارسال دوره باید تمام مراحل را به صورت کامل (100%) پشت سر
              گذاشته باشید.
            </p>
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-saveDraft-2) previous -->
          <b-button
            :disabled="isSaving"
            class="mx-1"
            variant="success"
            @click="saveDraft()"
            >ثبت پیشنویس</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 10"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW
import mixin from "../../mixins/utilities";
import YearModal from "@/components/YearModal";
export default {
  mixins: [mixin],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    compact: Compact,
    ColourPicker,
    YearModal
  },
  data() {
    return {
      reactivity: false,
      reactivity2: false,
      otherUniHelp: "",
      doiLoading: "",
      check: false,
      infoo: "",
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      pageLoaded: false,
      moment: moment,
      show: false,
      checkbox: "",
      checkbox2: "",
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      chek: "",
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        postDocPhDCertificateFile: "",
        obligations: [],
      },

      colleague: {},
      universities: [],
      accelerators: [],
      iran: [],
      otherUniversity: "",
      mehvars: [],
      isSaving: false,
      color: "",
      otherMehvars: "",
      zone: new Array(6).fill(false),
      //proposal.requestProducts
      achievmentitems: [
        {
          name: "",
          amount: "",
          fullfill: "",
        },
      ],
      tabIndex: 1,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      colleaguePosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      taahol: "",
      max: 100,
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [{ subject: "", Iyear: "", description: "" }],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "Iyear", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      inventionItemMaster: [],
      inventionFieldMaster: [
        { key: "Msubject", label: "عنوان" },
        { key: "Myear", label: "سال" },
        { key: "Mdescription", label: "توضیحات" },
      ],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],

      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      //additionalFiles: {
      //  zero: { uploadPercentage: 0 },
      //  research: { uploadPercentage: 0 },
      //  industry: { uploadPercentage: 0 },
      //  agreement: { uploadPercentage: 0 },
      //  others1: { uploadPercentage: 0 },
      //  others2: { uploadPercentage: 0 },
      //  others3: { uploadPercentage: 0 },
      //},
      //otherFiles: new Array(19).fill({
      //  isUploaded: false,
      //}),
      myshow: false,

      deviceCostItem: [],
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      otherCostItem: [
        { name: "تكثیر اوراق ، تایپ و تهیه گزارشها و مراجع", totalPrice: 0 },
        { name: "ارتباطات، حمل ونقل ، پست ، دورنویس و باربری", totalPrice: 0 },
        { name: "هزینه های پیش بینی نشده", totalPrice: 0 },
      ],
      allCostItem: [
        { name: "پرسنلی ", totalPrice: 0 },
        { name: "ارتباطات، حمل ونقل ، پست ، دورنویس و باربری", totalPrice: 0 },
        { name: "هزینه های پیش بینی نشده", totalPrice: 0 },
      ],
      allCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "پرسنلی ", label: "پرسنلی" },
      ],

      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
        { key: "operation", label: "" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
        { key: "operation", label: "" },
      ],
      perCosts: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      perPrices: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      tripCostItem: [],
      options1: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      options2: [
        {
          value: "تمام وقت",
          text: "تمام وقت",
        },
        {
          value: "پاره وقت",
          text: "پاره وقت",
        },
      ],
      sources: [
        {
          value: "داخلی",
          text: "داخلی",
        },
        {
          value: "خارجی",
          text: "خارجی",
        },
      ],

      deviceTypes: [
        { value: "مصرفی", text: "مصرفی" },
        { value: "سرمایه‌ای", text: "سرمایه‌ای" },
      ],

      PersonnelCostItem: [],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت (تومان)" },
        { key: "perPersonCost", label: "نفر ساعت مورد نیاز" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
        { key: "operation", label: "" },
      ],

      config: {
        locale: {
          name: "en",
        },

        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      fileTitles: [
        "نامه صنعت یا شرکت",
        "نامه شورای پژوهش یا فناوری دانشگاه",
        "توافقنامه دانشگاه با صنعت",
        "نامه اعلام شماره حساب هزینه ای دانشگاه",
        "رزومه استاد راهنما (فارسی)",
        "رزومه استاد راهنما (انگلیسی)",
        "رزومه متقاضی (فارسی)",
        "رزومه متقاضی (انگلیسی)",
        "حکم عضویت هیئت علمی استاد",
        "مقاله اول",
        "مقاله دوم",
        "مقاله سوم",
        "مقاله چهارم",
        "مقاله پنجم",
        "مدرک برگزیدگان جشنواره‌ها",
        "مستندات طرح های کاربردی",
        "مدرک دکتری پژوهشگر",
        "معرفی نامه",
      ],
      isLoaded: true,
      showTop: false,
      gettingMobile: false,
      supervisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          natCode: "",
          email: "",
          position: "",
          lastDegree: "",
          universityId: "",
          universityOther: "",
          universityJobId: "",
          universityJobOther: "",
          phdThesisSubject: "",
          academicRank: "",
          scienceCommitteeType: "",
          article: "",
          resumeFileId: "",
          resumeFile: "",
          doi1: "",
          doi2: "",
          doi3: "",
          doi4: "",
          doi5: "",
          internationalPatent: "",
          internationalPatentTitle: "",
          internationalPatentYear: "",
          internationalPatentDescription: "",
          researchFestivals: "",
          researchFestivalsTitle: "",
          notSupervisor: "",
        },
      ],
      companies: [],
      uploadedFiles: new Array(18).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      files: [
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
      ],
      showYearModal: false,
      showSupervisorYearModal: false,
      eduReactivity: false,
    };
  },

  methods: {
    getItemYear(value) {
      this.proposal.researcherInternationalPatentYear = value;
    },
    getShowModal(value) {
      this.showYearModal = value;
      this.eduReactivity = !this.eduReactivity;
    },
    getSupervisorYear(value) {
      this.supervisors[0].internationalPatentYear = value;
    },
    getSupervisorShowModal(value) {
      this.showSupervisorYearModal = value;
      this.eduReactivity = !this.eduReactivity;
    },
    viewList(type) {
      localStorage.setItem("list", type);
      let link = "/map";
      window.open(link, "_blank");
    },
    getMobile() {
      this.gettingMobile = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/profile/mobile",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.gettingMobile = false;
          this.proposal.researcherMobile = res.data;
        })
        .catch((err) => {
          this.gettingMobile = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.otherMehvars = "";
    },
    addOrgCost() {
      // NOTE (m-addOrgCost) to add organization costs in the relevant sections
      this.proposal.participationOrganizationBudget.push({
        name: "",
        description: "",
        totalPrice: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های همکاری با موسسات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    addDeviceCost() {
      // NOTE (m-addDeviceCost) to add device costs in the relevant sections
      this.proposal.purchases.push({
        name: "",
        // consumable: "",
        // fund: 0,
        type: "",
        source: "",
        number: 0,
        perPrice: 0,
        totalPrice: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های تجهیزات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    getCompanyInfo() {
      if (this.proposal.companyId != this.notCompany) {
        this.proposal.companyName = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].name;
        this.proposal.companyRegistrationNumber = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].registrationNumber;
        this.proposal.companyNationalId = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].nationalId;
      }
    },
    addCost1() {
      // NOTE (m-addCost1) to add personnel costs in the relevant sections
      this.proposal.personnelCosts.push({
        name: "",
        degree: "",
        cooperationType: "",
        cooperationHour: 0,
        perPersonCost: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های تجهیزات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "blue",
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    addTripCost() {
      // NOTE (m-addTripCost) to add trip costs in the relevant sections
      this.proposal.travelExpenses.push({
        destination: "",
        reason: "",
        number: "",
        // day: "",
        cost: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های تجهیزات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    delCost1(order) {
      // NOTE (m-delCost1) to romove personnel costs in the relevant sections
      if (this.proposal.personnelCosts.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد هزینه باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.personnelCosts.splice(order, 1);
      }
    },
    delTripCost(order) {
      // NOTE (m-delTripCost) to remove trip costs in the relevant sections
      this.proposal.travelExpenses.splice(order, 1);
    },
    delService(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.gantData.splice(order, 1);
    },
    delDeviceCost(order) {
      // NOTE (m-delDeviceCost) to remove device costs in the relevant sections
      this.proposal.purchases.splice(order, 1);
    },
    delOrgCost(order) {
      // NOTE (m-delOrgCost) to remove organization costs in the relevant sections
      this.proposal.participationOrganizationBudget.splice(order, 1);
    },
    doiCheck(doi, index) {
      this.doiLoading[index] = true;
      this.check = !this.check;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/doi",
          { doi: doi },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.totalDOIData = res.data;
          this.toast("شناسه‌ی وارد شده\n" + doi + "\n!معتبر است", "info");
          this.doiLoading[index] = false;
          this.check = !this.check;
        })
        .catch(() => {
          this.toast("شناسه‌ی وارد شده\n" + doi + "\n!معتبر نیست", "error");
          this.doiLoading[index] = false;
          this.check = !this.check;
        });
    },
    nameKeydown(e) {
      if (/[^a-zA-Z 0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
      ////////////////

      // save draft !!!
      this.saveDraft();
      ////////////////
    },
    changedStartDate(data, index) {
      if (
        moment(data.startDate, "jYYYY/jM/JD").format("X") >
        moment(data.dueDate, "jYYYY/jM/JD").format("X")
      ) {
        this.proposal.gantData[index].dueDate = this.computedMinDate(
          data.startDate
        );
      }
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/request/postDoc/upload?requestId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.uploadedFiles[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              this.files[index].title = this.fileTitles[index];

              // this.uploadedFiles[index].title = d.data[0].showName;
              // this.uploadedFiles[index].description =
              //   this.descriptionTemplates[index].description;

              // this.research = this.uploadedFiles[1]
              //   ? this.uploadedFiles[1].name
              //   : false;
              // this.industry = this.uploadedFiles[2]
              //   ? this.uploadedFiles[2].name
              //   : false;
              // this.agreement = this.uploadedFiles[3]
              //   ? this.uploadedFiles[3].name
              //   : false;
              // this.account = this.uploadedFiles[7]
              //   ? this.uploadedFiles[7].name
              //   : false;

              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    supUploadFile(file, index) {
      // NOTE  to upload colleagues files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.supervisors[0].showProgress = true;
        this.supervisors[0].variant = "info";
        this.supervisors[0].uploadPercentage = 0;
        this.supervisors[0].isUploaded = false;
        this.supervisors[0].uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/request/postDoc/upload?requestId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.supervisors[0].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.supervisors[0].isUploaded = true;
              this.supervisors[0].uploadPercentage = 100;
              this.supervisors[0].striped = false;
              this.supervisors[0].variant = "success";
              this.supervisors[0].uploadButDisable = false;
              this.supervisors[0].resumeFile = d.data.url;
              this.supervisors[0].resumeFileId = d.data.id;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.supervisors[0].file = null;
            this.supervisors[0].uploadPercentage = 0;
            this.supervisors[0].isUploaded = false;
          });
      }
    },
    //myUpload(file, index) {
    //  if (!file) {
    //    return;
    //  }
    //  //CHECK FILE SIZE
    //  let sizeMB = file.size / 1024 / 1024;

    //  if (sizeMB > 5) {
    //    this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
    //    return;
    //  } else {
    //    // START UPLOAD PROCESS
    //    this.myFile[index].showProgress = true;
    //    this.myFile[index].variant = "info";
    //    this.myFile[index].uploadPercentage = 0;
    //    this.myFile[index].isUploaded = false;
    //    this.myFile[index].uploadButDisable = true;
    //    var formData = new FormData();
    //    formData.append(file.name, file);

    //    this.$http
    //      .post(
    //        this.baseUrl +
    //          "/setad/newUploads/private?id=" +
    //          this.$route.params.id,
    //        formData,
    //        {
    //          headers: {
    //            Authorization: "Bearer: " + localStorage.getItem("userId"),
    //          },
    //          onUploadProgress: ((progressEvent) => {
    //            this.myFile[index].uploadPercentage =
    //              Math.round(
    //                (progressEvent.loaded * 100) / progressEvent.total
    //              ) - 1;
    //          }).bind(this),
    //        }
    //      )
    //      .then((res) => {
    //        if (res.status == 200) {
    //          this.myFile[index].isUploaded = true;
    //          this.myFile[index].uploadPercentage = 100;
    //          this.myFile[index].striped = false;
    //          this.myFile[index].variant = "success";
    //          this.myFile[index].uploadButDisable = false;
    //          this.uploadedFiles[index] = res.data[0];

    //          this.uploadedFiles.forEach((x, index) => {
    //            if (x) this["myTempFile" + index] = true;
    //            else this["myTempFile" + index] = false;
    //          });

    //          this.uploadedFiles[index].title = res.data[0].showName;
    //          this.uploadedFiles[index].description =
    //            this.descriptionTemplates[index].description;
    //        }
    //      })
    //      .catch((err) => {
    //        console.log(err)
    //        this.uploadedFiles[index] = "";
    //        this.file[index] = null;
    //        this.myFile[index].uploadPercentage = 0;
    //        this.myFile[index].isUploaded = false;
    //        this.myFile[index].showProgress = false;
    //        this["myTempFile" + index] = false;
    //      });
    //  }
    //},
    delFile(order, fileName) {
      //this.uploadedFiles[order] = "";
      //this.file[order] = null;
      //this.myFile[order].uploadPercentage = 0;
      //this.myFile[order].isUploaded = false;
      //this.myFile[order].showProgress = false;
      //this["myTempFile" + order] = false;
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    isEmail(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isID(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    isEmailClass(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? true : false) : false;
    },
    isIDClass(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? true : false) : false;
    },
    addAchievment() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.requestProducts.push({
        name: "",
        amount: "",
        fullfill: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delAchievment(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.proposal.requestProducts.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد دستاورد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.requestProducts.splice(order, 1);
      }
    },
    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },

    saveDraft() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.showTop = true;
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;
      //this.executor.otherUniversity = this.otherUniHelp;
      //let third = [];
      //third[0] = this.colleague;
      this.supervisors[0].doi1 = this.supervisors[0].article
        ? this.supervisors[0].doi1
        : "";
      this.supervisors[0].doi2 = this.supervisors[0].article
        ? this.supervisors[0].doi2
        : "";
      this.supervisors[0].doi3 = this.supervisors[0].article
        ? this.supervisors[0].doi3
        : "";
      this.supervisors[0].doi4 = this.supervisors[0].article
        ? this.supervisors[0].doi4
        : "";
      this.supervisors[0].doi5 = this.supervisors[0].article
        ? this.supervisors[0].doi5
        : "";
      this.supervisors[0].internationalPatentTitle = this.supervisors[0]
        .internationalPatent
        ? this.supervisors[0].internationalPatentTitle
        : "";
      this.supervisors[0].internationalPatentYear = this.supervisors[0]
        .internationalPatent
        ? this.supervisors[0].internationalPatentYear
        : "";
      this.supervisors[0].internationalPatentDescription = this.supervisors[0]
        .internationalPatent
        ? this.supervisors[0].internationalPatentDescription
        : "";

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/postDoc/draft",
          {
            requestId: this.$route.params.id,
            uploadedFiles: this.files,
            enSubject: this.proposal.enSubject,
            faSubject: this.proposal.faSubject,
            initialIsSupported: this.proposal.initialIsSupported,
            initialSupportedType: this.proposal.initialSupportedType,
            initialOtherSupport: this.proposal.initialOtherSupport,
            initialSupportDescription: this.proposal.initialSupportDescription,
            universityId: this.proposal.universityId,
            otherUniversity: this.proposal.otherUniversity,
            mehvarId: this.proposal.mehvarId,
            otherMehvars: this.proposal.otherMehvars,
            typeStudy: this.proposal.typeStudy,
            typeSystemicDevelopmental: this.proposal.typeSystemicDevelopmental,
            typePractical: this.proposal.typePractical,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            researcherName: this.proposal.researcherName,
            researcherLastName: this.proposal.researcherLastName,
            researcherMobile: this.proposal.researcherMobile,
            researcherEmail: this.proposal.researcherEmail,
            researcherNatCode: this.proposal.researcherNatCode,
            researcherFax: this.proposal.researcherFax,
            researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
            researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
            researcherUniversityId: this.proposal.researcherUniversityId,
            researcherUniversityOther: this.proposal.researcherUniversityOther,
            researcherPhDField: this.proposal.researcherPhDField,
            researcherPhDThesisSubject:
              this.proposal.researcherPhDThesisSubject,
            researcherPhDThesisDefenceDate:
              this.proposal.researcherPhDThesisDefenceDate,
            researcherPhDCertificateDate:
              this.proposal.researcherPhDCertificateDate,
            researcherArticle: this.proposal.researcherArticle
              ? this.proposal.researcherArticle
              : "",
            researcherDoi1: this.proposal.researcherArticle
              ? this.proposal.researcherDoi1
              : "",
            researcherDoi2: this.proposal.researcherArticle
              ? this.proposal.researcherDoi2
              : "",
            researcherDoi3: this.proposal.researcherArticle
              ? this.proposal.researcherDoi3
              : "",
            researcherInternationalPatent:
              this.proposal.researcherInternationalPatent,
            researcherInternationalPatentTitle: this.proposal
              .researcherInternationalPatent
              ? this.proposal.researcherInternationalPatentTitle
              : "",
            researcherInternationalPatentYear: this.proposal
              .researcherInternationalPatent
              ? this.proposal.researcherInternationalPatentYear
              : "",
            researcherInternationalPatentDescription: this.proposal
              .researcherInternationalPatent
              ? this.proposal.researcherInternationalPatentDescription
              : "",

            //proposal

            supervisors: this.supervisors,
            abstract: this.proposal.abstract,
            requestNecessity: this.proposal.requestNecessity,
            majorGoals: this.proposal.majorGoals,
            minorGoals: this.proposal.minorGoals,
            benefitsToCountry: this.proposal.benefitsToCountry,
            methodology: this.proposal.methodology,
            requestProducts: this.proposal.requestProducts,
            executionHistorySimilar: this.proposal.executionHistorySimilar,
            internationalPartners: this.proposal.internationalPartners,
            references: this.proposal.references,
            postDocLastSupports: this.proposal.postDocLastSupports,

            companyId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyId
                : "",
            otherCompanyName:
              this.proposal.companyId == this.notCompany &&
              this.proposal.commercializingType == "company"
                ? this.proposal.otherCompanyName
                : "",
            otherCompanyRegistrationNumber:
              this.proposal.companyId == this.notCompany &&
              this.proposal.commercializingType == "company"
                ? this.proposal.otherCompanyRegistrationNumber
                : "",
            otherCompanyNationalId:
              this.proposal.companyId == this.notCompany &&
              this.proposal.commercializingType == "company"
                ? this.proposal.otherCompanyNationalId
                : "",
            companyName:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyName
                : "",
            companyRegistrationNumber:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyRegistrationNumber
                : "",
            companyNationalId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyNationalId
                : "",
            companyProducts:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyProducts
                : "",
            companyContactInfo:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyContactInfo
                : "",

            commercializingType: this.proposal.commercializingType,
            commercializingObligation1:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation1
                : "",
            commercializingObligation2:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation2
                : "",
            acceleratorId:
              this.proposal.commercializingType == "accelerator"
                ? this.proposal.acceleratorId
                : "",

            //Business
            interactUniversityCenters: this.proposal.interactUniversityCenters,
            targetMarket: this.proposal.targetMarket,
            productSalesForecast: this.proposal.productSalesForecast,
            employment: this.proposal.employment,
            durationCooperation: this.proposal.durationCooperation,
            estimationProductionProjectRevenue:
              this.proposal.estimationProductionProjectRevenue,
            competitiveProductsLevelCompetitiveness:
              this.proposal.competitiveProductsLevelCompetitiveness,
            productAdvantages: this.proposal.productAdvantages,

            //Scheduling
            gantData: this.proposal.gantData,

            //Financial
            personnelCosts: this.proposal.personnelCosts,
            budget: this.computedTotalCost,
            //budget : "0",

            //Files
            letterUniversityResearchFileId:
              this.proposal.letterUniversityResearchFileId,
            letterCompanyFileId: this.proposal.letterCompanyFileId,
            universityAgreementIndustryFileId:
              this.proposal.universityAgreementIndustryFileId,
            letterUniversityAccountNumberFileId:
              this.proposal.letterUniversityAccountNumberFileId,
            postDocTeacherResumeFaFileId:
              this.proposal.postDocTeacherResumeFaFileId,
            postDocTeacherResumeEnFileId:
              this.proposal.postDocTeacherResumeEnFileId,
            postDocResearcherResumeFaFileIdFileId:
              this.proposal.postDocResearcherResumeFaFileIdFileId,
            postDocResearcherResumeEnFileIdFileId:
              this.proposal.postDocResearcherResumeEnFileIdFileId,
            postDocProfessorFacultyMembershipFileId:
              this.proposal.postDocProfessorFacultyMembershipFileId,
            postDocArticle1FileId: this.proposal.postDocArticle1FileId,
            postDocArticle2FileId: this.proposal.postDocArticle2FileId,
            postDocArticle3FileId: this.proposal.postDocArticle3FileId,
            postDocArticle4FileId: this.proposal.postDocArticle4FileId,
            postDocArticle5FileId: this.proposal.postDocArticle5FileId,
            postDocResearchFestivalFileId:
              this.proposal.postDocResearchFestivalFileId,
            postDocResearchFestivalFileTitle:
              this.proposal.postDocResearchFestivalFileTitle,
            postDocResearchFestivalFileDescription:
              this.proposal.postDocResearchFestivalFileDescription,
            postDocApplicationDocumentationFileId:
              this.proposal.postDocApplicationDocumentationFileId,
            postDocPhDCertificateFileId:
              this.proposal.postDocPhDCertificateFileId,
            postDocIntroductionLetterFileId:
              this.proposal.postDocIntroductionLetterFileId,
            promiseArrays: this.proposal.promiseArrays,
            //researcherUniversityJobId:this.proposal.researcherUniversityJobId,
            //researcherUniversityJobOther:this.proposal.researcherUniversityJobOther,
            duration:
              this.proposal.gantData.length > 0
                ? (Math.max(
                    ...this.proposal.gantData.map((x) =>
                      new Date(
                        moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                      ).getTime()
                    )
                  ) -
                    Math.min(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.startDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    )) /
                  3600 /
                  24 /
                  1000
                : 0,
            // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
            startDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",
            // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
            finalDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.max(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",

            travelExpenses: this.proposal.travelExpenses,
            purchases: this.proposal.purchases,
            participationOrganizationBudget:
              this.proposal.participationOrganizationBudget,
            otherCosts: this.proposal.otherCosts,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          this.isSaving = false;
          // router.push("/researcher/completeProposal/" + res.data);
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    submit() {
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;
      this.executor.otherUniversity = this.otherUniHelp;
      let third = [];
      third[0] = this.colleague;
      this.supervisors[0].doi1 = this.supervisors[0].article
        ? this.supervisors[0].doi1
        : "";
      this.supervisors[0].doi2 = this.supervisors[0].article
        ? this.supervisors[0].doi2
        : "";
      this.supervisors[0].doi3 = this.supervisors[0].article
        ? this.supervisors[0].doi3
        : "";
      this.supervisors[0].doi4 = this.supervisors[0].article
        ? this.supervisors[0].doi4
        : "";
      this.supervisors[0].doi5 = this.supervisors[0].article
        ? this.supervisors[0].doi5
        : "";
      this.supervisors[0].internationalPatentTitle = this.supervisors[0]
        .internationalPatent
        ? this.supervisors[0].internationalPatentTitle
        : "";
      this.supervisors[0].internationalPatentYear = this.supervisors[0]
        .internationalPatent
        ? this.supervisors[0].internationalPatentYear
        : "";
      this.supervisors[0].internationalPatentDescription = this.supervisors[0]
        .internationalPatent
        ? this.supervisors[0].internationalPatentDescription
        : "";
      if (this.proposal.revision > 0) {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/postDoc/edit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              enSubject: this.proposal.enSubject,
              faSubject: this.proposal.faSubject,
              initialIsSupported: this.proposal.initialIsSupported,
              initialSupportedType: this.proposal.initialSupportedType,
              initialOtherSupport: this.proposal.initialOtherSupport,
              initialSupportDescription:
                this.proposal.initialSupportDescription,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              typeStudy: this.proposal.typeStudy,
              typeSystemicDevelopmental:
                this.proposal.typeSystemicDevelopmental,
              typePractical: this.proposal.typePractical,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              researcherName: this.proposal.researcherName,
              researcherLastName: this.proposal.researcherLastName,
              researcherMobile: this.proposal.researcherMobile,
              researcherEmail: this.proposal.researcherEmail,
              researcherNatCode: this.proposal.researcherNatCode,
              researcherFax: this.proposal.researcherFax,
              researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
              researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
              researcherUniversityId: this.proposal.researcherUniversityId,
              researcherUniversityOther:
                this.proposal.researcherUniversityOther,
              researcherPhDField: this.proposal.researcherPhDField,
              researcherPhDThesisSubject:
                this.proposal.researcherPhDThesisSubject,
              researcherPhDThesisDefenceDate:
                this.proposal.researcherPhDThesisDefenceDate,
              researcherPhDCertificateDate:
                this.proposal.researcherPhDCertificateDate,
              researcherArticle: this.proposal.researcherArticle,
              researcherDoi1: this.proposal.researcherArticle
                ? this.proposal.researcherDoi1
                : "",
              researcherDoi2: this.proposal.researcherArticle
                ? this.proposal.researcherDoi2
                : "",
              researcherDoi3: this.proposal.researcherArticle
                ? this.proposal.researcherDoi3
                : "",
              researcherInternationalPatent:
                this.proposal.researcherInternationalPatent,
              researcherInternationalPatentTitle: this.proposal
                .researcherInternationalPatent
                ? this.proposal.researcherInternationalPatentTitle
                : "",
              researcherInternationalPatentYear: this.proposal
                .researcherInternationalPatent
                ? this.proposal.researcherInternationalPatentYear
                : "",
              researcherInternationalPatentDescription: this.proposal
                .researcherInternationalPatent
                ? this.proposal.researcherInternationalPatentDescription
                : "",

              //proposal
              supervisors: this.supervisors,
              //supervisorIds: this.supervisors.id,
              abstract: this.proposal.abstract,
              requestNecessity: this.proposal.requestNecessity,
              majorGoals: this.proposal.majorGoals,
              minorGoals: this.proposal.minorGoals,
              benefitsToCountry: this.proposal.benefitsToCountry,
              methodology: this.proposal.methodology,
              requestProducts: this.proposal.requestProducts,
              executionHistorySimilar: this.proposal.executionHistorySimilar,
              internationalPartners: this.proposal.internationalPartners,
              references: this.proposal.references,
              postDocLastSupports: this.proposal.postDocLastSupports,

              companyId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyId
                  : "",
              otherCompanyName:
                this.proposal.companyId == this.notCompany &&
                this.proposal.commercializingType == "company"
                  ? this.proposal.otherCompanyName
                  : "",
              otherCompanyRegistrationNumber:
                this.proposal.companyId == this.notCompany &&
                this.proposal.commercializingType == "company"
                  ? this.proposal.otherCompanyRegistrationNumber
                  : "",
              otherCompanyNationalId:
                this.proposal.companyId == this.notCompany &&
                this.proposal.commercializingType == "company"
                  ? this.proposal.otherCompanyNationalId
                  : "",
              companyName:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyName
                  : "",
              companyRegistrationNumber:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyRegistrationNumber
                  : "",
              companyNationalId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyNationalId
                  : "",
              companyProducts:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyProducts
                  : "",
              companyContactInfo:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyContactInfo
                  : "",

              commercializingType: this.proposal.commercializingType,
              commercializingObligation1:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation1
                  : "",
              commercializingObligation2:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation2
                  : "",
              acceleratorId:
                this.proposal.commercializingType == "accelerator"
                  ? this.proposal.acceleratorId
                  : "",

              //Business
              interactUniversityCenters:
                this.proposal.interactUniversityCenters,
              targetMarket: this.proposal.targetMarket,
              productSalesForecast: this.proposal.productSalesForecast,
              employment: this.proposal.employment,
              durationCooperation: this.proposal.durationCooperation,
              estimationProductionProjectRevenue:
                this.proposal.estimationProductionProjectRevenue,
              competitiveProductsLevelCompetitiveness:
                this.proposal.competitiveProductsLevelCompetitiveness,
              productAdvantages: this.proposal.productAdvantages,

              //Scheduling
              gantData: this.proposal.gantData,

              //Financial
              personnelCosts: this.proposal.personnelCosts,
              budget: this.computedTotalCost,
              //budget : "0",

              //Files
              letterUniversityResearchFileId:
                this.proposal.letterUniversityResearchFileId,
              letterCompanyFileId: this.proposal.letterCompanyFileId,
              universityAgreementIndustryFileId:
                this.proposal.universityAgreementIndustryFileId,
              letterUniversityAccountNumberFileId:
                this.proposal.letterUniversityAccountNumberFileId,
              postDocTeacherResumeFaFileId:
                this.proposal.postDocTeacherResumeFaFileId,
              postDocTeacherResumeEnFileId:
                this.proposal.postDocTeacherResumeEnFileId,
              postDocResearcherResumeFaFileIdFileId:
                this.proposal.postDocResearcherResumeFaFileIdFileId,
              postDocResearcherResumeEnFileIdFileId:
                this.proposal.postDocResearcherResumeEnFileIdFileId,
              postDocProfessorFacultyMembershipFileId:
                this.proposal.postDocProfessorFacultyMembershipFileId,
              postDocArticle1FileId: this.proposal.postDocArticle1FileId,
              postDocArticle2FileId: this.proposal.postDocArticle2FileId,
              postDocArticle3FileId: this.proposal.postDocArticle3FileId,
              postDocArticle4FileId: this.proposal.postDocArticle4FileId,
              postDocArticle5FileId: this.proposal.postDocArticle5FileId,
              postDocResearchFestivalFileId:
                this.proposal.postDocResearchFestivalFileId,
              postDocResearchFestivalFileTitle:
                this.proposal.postDocResearchFestivalFileTitle,
              postDocResearchFestivalFileDescription:
                this.proposal.postDocResearchFestivalFileDescription,
              postDocApplicationDocumentationFileId:
                this.proposal.postDocApplicationDocumentationFileId,
              postDocPhDCertificateFileId:
                this.proposal.postDocPhDCertificateFileId,
              postDocIntroductionLetterFileId:
                this.proposal.postDocIntroductionLetterFileId,
              promiseArrays: this.proposal.promiseArrays,
              //researcherUniversityJobId:this.proposal.researcherUniversityJobId,
              //researcherUniversityJobOther:this.proposal.researcherUniversityJobOther,
              duration:
                this.proposal.gantData.length > 0
                  ? (Math.max(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                    3600 /
                    24 /
                    1000
                  : 0,
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              startDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              finalDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",

              travelExpenses: this.proposal.travelExpenses,
              purchases: this.proposal.purchases,
              participationOrganizationBudget:
                this.proposal.participationOrganizationBudget,
              otherCosts: this.proposal.otherCosts,

              otherFile1Id: this.proposal.otherFile1Id,
              otherFile1Title: this.proposal.otherFile1Title,
              otherFile1Description: this.proposal.otherFile1Description,
              otherFile2Id: this.proposal.otherFile2Id,
              otherFile2Title: this.proposal.otherFile2Title,
              otherFile2Description: this.proposal.otherFile2Description,
              otherFile3Id: this.proposal.otherFile3Id,
              otherFile3Title: this.proposal.otherFile3Title,
              otherFile3Description: this.proposal.otherFile3Description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.isSaving = false;
            router.push("/researcher/postDoc/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.isSaving = false;
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/postDoc/submit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              enSubject: this.proposal.enSubject,
              faSubject: this.proposal.faSubject,
              initialIsSupported: this.proposal.initialIsSupported,
              initialSupportedType: this.proposal.initialSupportedType,
              initialOtherSupport: this.proposal.initialOtherSupport,
              initialSupportDescription:
                this.proposal.initialSupportDescription,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              typeStudy: this.proposal.typeStudy,
              typeSystemicDevelopmental:
                this.proposal.typeSystemicDevelopmental,
              typePractical: this.proposal.typePractical,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              researcherName: this.proposal.researcherName,
              researcherLastName: this.proposal.researcherLastName,
              researcherMobile: this.proposal.researcherMobile,
              researcherEmail: this.proposal.researcherEmail,
              researcherNatCode: this.proposal.researcherNatCode,
              researcherFax: this.proposal.researcherFax,
              researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
              researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
              researcherUniversityId: this.proposal.researcherUniversityId,
              researcherUniversityOther:
                this.proposal.researcherUniversityOther,
              researcherPhDField: this.proposal.researcherPhDField,
              researcherPhDThesisSubject:
                this.proposal.researcherPhDThesisSubject,
              researcherPhDThesisDefenceDate:
                this.proposal.researcherPhDThesisDefenceDate,
              researcherPhDCertificateDate:
                this.proposal.researcherPhDCertificateDate,
              researcherArticle: this.proposal.researcherArticle,
              researcherDoi1: this.proposal.researcherArticle
                ? this.proposal.researcherDoi1
                : "",
              researcherDoi2: this.proposal.researcherArticle
                ? this.proposal.researcherDoi2
                : "",
              researcherDoi3: this.proposal.researcherArticle
                ? this.proposal.researcherDoi3
                : "",
              researcherInternationalPatent:
                this.proposal.researcherInternationalPatent,
              researcherInternationalPatentTitle: this.proposal
                .researcherInternationalPatent
                ? this.proposal.researcherInternationalPatentTitle
                : "",
              researcherInternationalPatentYear: this.proposal
                .researcherInternationalPatent
                ? this.proposal.researcherInternationalPatentYear
                : "",
              researcherInternationalPatentDescription: this.proposal
                .researcherInternationalPatent
                ? this.proposal.researcherInternationalPatentDescription
                : "",

              //proposal
              supervisors: this.supervisors,
              //supervisorIds: this.supervisors.id,
              abstract: this.proposal.abstract,
              requestNecessity: this.proposal.requestNecessity,
              majorGoals: this.proposal.majorGoals,
              minorGoals: this.proposal.minorGoals,
              benefitsToCountry: this.proposal.benefitsToCountry,
              methodology: this.proposal.methodology,
              requestProducts: this.proposal.requestProducts,
              executionHistorySimilar: this.proposal.executionHistorySimilar,
              internationalPartners: this.proposal.internationalPartners,
              references: this.proposal.references,
              postDocLastSupports: this.proposal.postDocLastSupports,

              companyId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyId
                  : "",
              otherCompanyName:
                this.proposal.companyId == this.notCompany &&
                this.proposal.commercializingType == "company"
                  ? this.proposal.otherCompanyName
                  : "",
              otherCompanyRegistrationNumber:
                this.proposal.companyId == this.notCompany &&
                this.proposal.commercializingType == "company"
                  ? this.proposal.otherCompanyRegistrationNumber
                  : "",
              otherCompanyNationalId:
                this.proposal.companyId == this.notCompany &&
                this.proposal.commercializingType == "company"
                  ? this.proposal.otherCompanyNationalId
                  : "",
              companyName:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyName
                  : "",
              companyRegistrationNumber:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyRegistrationNumber
                  : "",
              companyNationalId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyNationalId
                  : "",
              companyProducts:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyProducts
                  : "",
              companyContactInfo:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyContactInfo
                  : "",

              commercializingType: this.proposal.commercializingType,
              commercializingObligation1:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation1
                  : "",
              commercializingObligation2:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation2
                  : "",
              acceleratorId:
                this.proposal.commercializingType == "accelerator"
                  ? this.proposal.acceleratorId
                  : "",

              //Business
              interactUniversityCenters:
                this.proposal.interactUniversityCenters,
              targetMarket: this.proposal.targetMarket,
              productSalesForecast: this.proposal.productSalesForecast,
              employment: this.proposal.employment,
              durationCooperation: this.proposal.durationCooperation,
              estimationProductionProjectRevenue:
                this.proposal.estimationProductionProjectRevenue,
              competitiveProductsLevelCompetitiveness:
                this.proposal.competitiveProductsLevelCompetitiveness,
              productAdvantages: this.proposal.productAdvantages,

              //Scheduling
              gantData: this.proposal.gantData,

              //Financial
              personnelCosts: this.proposal.personnelCosts,
              budget: this.computedTotalCost,
              //budget : "0",

              //Files
              letterUniversityResearchFileId:
                this.proposal.letterUniversityResearchFileId,
              letterCompanyFileId: this.proposal.letterCompanyFileId,
              universityAgreementIndustryFileId:
                this.proposal.universityAgreementIndustryFileId,
              letterUniversityAccountNumberFileId:
                this.proposal.letterUniversityAccountNumberFileId,
              postDocTeacherResumeFaFileId:
                this.proposal.postDocTeacherResumeFaFileId,
              postDocTeacherResumeEnFileId:
                this.proposal.postDocTeacherResumeEnFileId,
              postDocResearcherResumeFaFileIdFileId:
                this.proposal.postDocResearcherResumeFaFileIdFileId,
              postDocResearcherResumeEnFileIdFileId:
                this.proposal.postDocResearcherResumeEnFileIdFileId,
              postDocProfessorFacultyMembershipFileId:
                this.proposal.postDocProfessorFacultyMembershipFileId,
              postDocArticle1FileId: this.proposal.postDocArticle1FileId,
              postDocArticle2FileId: this.proposal.postDocArticle2FileId,
              postDocArticle3FileId: this.proposal.postDocArticle3FileId,
              postDocArticle4FileId: this.proposal.postDocArticle4FileId,
              postDocArticle5FileId: this.proposal.postDocArticle5FileId,
              postDocResearchFestivalFileId:
                this.proposal.postDocResearchFestivalFileId,
              postDocResearchFestivalFileTitle:
                this.proposal.postDocResearchFestivalFileTitle,
              postDocResearchFestivalFileDescription:
                this.proposal.postDocResearchFestivalFileDescription,
              postDocApplicationDocumentationFileId:
                this.proposal.postDocApplicationDocumentationFileId,
              postDocPhDCertificateFileId:
                this.proposal.postDocPhDCertificateFileId,
              postDocIntroductionLetterFileId:
                this.proposal.postDocIntroductionLetterFileId,
              promiseArrays: this.proposal.promiseArrays,
              //researcherUniversityJobId:this.proposal.researcherUniversityJobId,
              //researcherUniversityJobOther:this.proposal.researcherUniversityJobOther,
              duration:
                this.proposal.gantData.length > 0
                  ? (Math.max(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                    3600 /
                    24 /
                    1000
                  : 0,
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              startDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              finalDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",

              travelExpenses: this.proposal.travelExpenses,
              purchases: this.proposal.purchases,
              participationOrganizationBudget:
                this.proposal.participationOrganizationBudget,
              otherCosts: this.proposal.otherCosts,

              otherFile1Id: this.proposal.otherFile1Id,
              otherFile1Title: this.proposal.otherFile1Title,
              otherFile1Description: this.proposal.otherFile1Description,
              otherFile2Id: this.proposal.otherFile2Id,
              otherFile2Title: this.proposal.otherFile2Title,
              otherFile2Description: this.proposal.otherFile2Description,
              otherFile3Id: this.proposal.otherFile3Id,
              otherFile3Title: this.proposal.otherFile3Title,
              otherFile3Description: this.proposal.otherFile3Description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.isSaving = false;
            router.push("/researcher/postDoc/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.isSaving = false;
          });
      }
    },

    onMounted() {
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;
      // NOTE (MOUNTED) to show the profile of user
      this.doiLoading = JSON.parse(JSON.stringify(new Array(8).fill(false)));

      //getting info
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/postDoc/getInfo",
          {
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data;
          this.proposal.obligations = [];
          this.files = res.data.uploadedFiles;
          !this.proposal.supervisors.length
            ? (this.proposal.supervisors = [
                {
                  id: "",
                  name: "",
                  lastName: "",
                  mobile: "",
                  natCode: "",
                  email: "",
                  position: "",
                  lastDegree: "",
                  UniversityId: "",
                  UniversityOther: "",
                  UniversityJobId: "",
                  UniversityJobOther: "",
                  phdThesisSubject: "",
                  academicRank: "",
                  scienceCommitteeType: "",
                  article: "",
                  resumeFileId: "",
                  resumeFile: "",
                  doi1: "",
                  doi2: "",
                  doi3: "",
                  doi4: "",
                  doi5: "",
                  internationalPatent: "",
                  internationalPatentTitle: "",
                  internationalPatentYear: "",
                  internationalPatentDescription: "",
                  researchFestivals: "",
                  researchFestivalsTitle: "",
                  notSupervisor: "",
                },
              ])
            : (this.supervisors = res.data.supervisors);

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
            this.pageLoaded = true;
          }, 200);

          // this.additionalFiles = JSON.parse(res.data.project.files);

          this.fileBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      this.$bvModal.show("loading");
      this.isLoaded = false;

      // getting all universities
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
          this.isLoaded = true;

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      //getting companies
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت‌ها",
            })
          );
          this.companies.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
          this.isLoaded = true;

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      // getting all accelerators
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      // getting all mehvars
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          // this.mehvars.push(
          //   new Object({
          //     id: 1,
          //     text: "سایر محورها",
          //     universityId: 1
          //   })
          // );
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/public/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    achievmentClass() {
      let progress = 0;
      let total = 0; //default number of price variables due to last table

      if (this.proposal.requestProducts) {
        total += this.proposal.requestProducts.length * 3;
        this.proposal.requestProducts.forEach((x) => {
          x.name ? progress++ : 1;
          x.amount ? progress++ : 1;
          x.fullfill ? progress++ : 1;
        });
        if (total / progress == 1) {
          return "done";
        } else {
          return "required";
        }
      } else {
        return "required";
      }
    },
    computedTitle1() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyRegistrationNumber) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
    computedTitle2() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyNationalId) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
    // NOTE university class if the university was "سایر"
    universityClass() {
      if (this.proposal.researcherUniversityId == this.notUniversity) {
        if (this.proposal.researcherUniversityOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.proposal.researcherUniversityId) {
          return "done";
        } else {
          return "required";
        }
      }
    },

    //universityJobClass() {
    //  if (this.proposal.researcherUniversityJobId == 1) {
    //    if (this.proposal.researcherUniversityJobOther) {
    //      return "done";
    //    } else {
    //      return "required";
    //    }
    //  } else {
    //    if (this.proposal.researcherUniversityJobId) {
    //      return "done";
    //    } else {
    //      return "required";
    //    }
    //  }
    //},

    supervisorUniversityClass() {
      if (this.supervisors[0].universityId == this.notUniversity) {
        if (this.supervisors[0].universityOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.supervisors[0].universityId) {
          return "done";
        } else {
          return "required";
        }
      }
    },

    supervisorUniversityJobClass() {
      if (this.supervisors[0].universityJobId == 1) {
        if (this.supervisors[0].universityJobOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.supervisors[0].universityJobId) {
          return "done";
        } else {
          return "required";
        }
      }
    },

    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },

    step1progress() {
      let progress = 0;
      this.proposal.enSubject ? progress++ : 1;

      if (this.proposal.mehvarId && this.proposal.mehvarId != this.notMehvar) {
        progress++;
      } else {
        if (this.proposal.mehvarId == this.notMehvar) {
          if (this.proposal.otherMehvars) {
            progress++;
          }
        }
      }

      if (
        this.proposal.universityId &&
        this.proposal.universityId != this.notUniversity
      ) {
        progress++;
      } else {
        if (
          this.proposal.universityId == this.notUniversity &&
          this.proposal.otherUniversity
        ) {
          progress++;
        }
      }

      this.proposal.typeStudy ||
      this.proposal.typeSystemicDevelopmental ||
      this.proposal.typePractical
        ? progress++
        : 1;

      this.proposal.zoneMedicine ||
      this.proposal.zoneAgriculture ||
      this.proposal.zoneEnvironment ||
      this.proposal.zoneIndustrial ||
      this.proposal.zoneBioComputing ||
      this.proposal.zoneOther
        ? progress++
        : 1;
      progress = parseInt((progress / 5) * 100);
      return progress;
    },

    step2progress() {
      // NOTE (c-step2Progress) previous
      let progress = 0;
      let total = 13;

      this.proposal.researcherArticle ? total++ : 1;

      this.proposal.researcherInternationalPatent ? total++ : 1;

      this.proposal.researcherName ? progress++ : 1;
      this.proposal.researcherLastName ? progress++ : 1;
      this.checkCodeMeli(this.proposal.researcherNatCode) ? progress++ : 1;
      this.proposal.researcherMobile ? progress++ : 1;
      this.proposal.researcherFax ? progress++ : 1;

      this.validateEmail(this.proposal.researcherEmail) ? progress++ : 1;
      this.proposal.researcherStateId ? progress++ : 1;

      this.proposal.researcherCityId ? progress++ : 1;
      // NOTE for computing percentage if the university was "سایر"
      if (this.proposal.researcherUniversityId) {
        if (this.proposal.researcherUniversityId != this.notUniversity) {
          progress++;
        } else {
          if (this.proposal.researcherUniversityOther) {
            progress++;
          }
        }
      }
      //this.proposal.researcherLastDegree ? progress++ : 1;

      if (this.proposal.researcherArticle) {
        if (
          this.proposal.researcherDoi1 &&
          this.proposal.researcherDoi2 &&
          this.proposal.researcherDoi3
        ) {
          progress++;
        }
      }
      if (this.proposal.researcherInternationalPatent) {
        this.proposal.researcherInternationalPatentTitle &&
        this.proposal.researcherInternationalPatentYear &&
        this.proposal.researcherInternationalPatentDescription
          ? progress++
          : 1;
      }
      this.proposal.researcherPhDThesisSubject ? progress++ : 1;
      this.proposal.researcherPhDThesisDefenceDate ? progress++ : 1;
      this.proposal.researcherPhDCertificateDate ? progress++ : 1;
      this.proposal.researcherPhDField ? progress++ : 1;

      progress = parseInt((progress / total) * 100);
      return progress;
    },

    step3progress() {
      // NOTE (c-step2Progress) previous
      let progress = 0;
      let total = 14;

      this.supervisors[0].article && this.supervisors[0].internationalPatent
        ? total++
        : 1;

      this.supervisors[0].name ? progress++ : 1;
      this.supervisors[0].lastName ? progress++ : 1;
      this.checkCodeMeli(this.supervisors[0].natCode) ? progress++ : 1;
      this.supervisors[0].mobile ? progress++ : 1;
      this.supervisors[0].position ? progress++ : 1;
      this.supervisors[0].phdThesisSubject ? progress++ : 1;
      this.supervisors[0].academicRank ? progress++ : 1;
      this.supervisors[0].scienceCommitteeType ? progress++ : 1;
      this.supervisors[0].lastDegree ? progress++ : 1;
      this.supervisors[0].resumeFile ? progress++ : 1;

      this.validateEmail(this.supervisors[0].email) ? progress++ : 1;
      // NOTE for computing percentage if the university was "سایر"
      if (this.supervisors[0].universityId) {
        if (this.supervisors[0].universityId != this.notUniversity) {
          progress++;
        } else {
          if (this.supervisors[0].universityOther) {
            progress++;
          }
        }
      }

      if (this.supervisors[0].universityJobId) {
        if (this.supervisors[0].universityJobId != this.notUniversity) {
          progress++;
        } else {
          if (this.supervisors[0].universityJobOther) {
            progress++;
          }
        }
      }

      if (this.supervisors[0].article) {
        if (
          this.supervisors[0].doi1 &&
          this.supervisors[0].doi2 &&
          this.supervisors[0].doi3 &&
          this.supervisors[0].doi4 &&
          this.supervisors[0].doi5
        ) {
          progress++;
        }
      }
      if (this.supervisors[0].internationalPatent) {
        if (
          this.supervisors[0].internationalPatentTitle &&
          this.supervisors[0].internationalPatentYear &&
          this.supervisors[0].internationalPatentDescription
        ) {
          progress++;
        }
      }

      progress = parseInt((progress / total) * 100);
      return progress;
    },

    step4progress() {
      // NOTE (c-step4Progress) previous
      let progress = 0;
      let total = 10;
      // if (this.proposal.requestProducts.length == 0) return 0;
      this.chek >= 100 ? progress++ : 1;
      this.proposal.requestNecessity ? progress++ : 1;
      this.proposal.majorGoals ? progress++ : 1;
      this.proposal.minorGoals ? progress++ : 1;
      this.proposal.benefitsToCountry ? progress++ : 1;
      this.proposal.methodology ? progress++ : 1;
      this.proposal.executionHistorySimilar ? progress++ : 1;
      this.proposal.internationalPartners ? progress++ : 1;
      this.proposal.references ? progress++ : 1;
      this.proposal.postDocLastSupports ? progress++ : 1;
      if (this.proposal.requestProducts.length != 0) {
        total += this.proposal.requestProducts.length * 3;
        this.proposal.requestProducts.forEach((x) => {
          x.name ? progress++ : 1;
          x.amount ? progress++ : 1;
          x.fullfill ? progress++ : 1;
        });
      }
      progress = parseInt((progress / total) * 100);

      return progress;
    },

    step5progress() {
      // NOTE (c-step5Progress) previous
      let progress = 0;

      this.proposal.interactUniversityCenters ? progress++ : 1;
      this.proposal.targetMarket ? progress++ : 1;
      this.proposal.estimationProductionProjectRevenue ? progress++ : 1;
      this.proposal.employment ? progress++ : 1;
      this.proposal.durationCooperation ? progress++ : 1;
      this.proposal.productSalesForecast ? progress++ : 1;
      this.proposal.competitiveProductsLevelCompetitiveness ? progress++ : 1;
      this.proposal.productAdvantages ? progress++ : 1;
      if (this.proposal.commercializingType == "company") {
        if (
          this.proposal.companyId &&
          this.proposal.companyId != this.notCompany
        ) {
          progress++;
        }
        if (this.proposal.companyId == this.notCompany) {
          this.proposal.otherCompanyName ? progress++ : 1;

          this.proposal.otherCompanyRegistrationNumber ? progress++ : 1;

          this.proposal.otherCompanyNationalId ? progress++ : 1;
        }
        this.proposal.companyProducts ? progress++ : 1;
        this.proposal.companyContactInfo ? progress++ : 1;
        this.proposal.letterCompanyFile ? progress++ : 1;

        progress =
          this.proposal.companyId != this.notCompany
            ? parseInt((progress / 12) * 100)
            : parseInt((progress / 14) * 100);
      } else if (this.proposal.commercializingType == "accelerator") {
        this.proposal.acceleratorId ? progress++ : 1;

        progress = parseInt((progress / 9) * 100);
      } else if (this.proposal.commercializingType == "none") {
        this.proposal.commercializingObligation1 ? progress++ : 1;
        this.proposal.commercializingObligation2 ? progress++ : 1;
        this.reactivity = !this.reactivity;

        progress = parseInt((progress / 10) * 100);
      }

      return progress;
    },

    step6progress() {
      // NOTE (c-step6Progress) previous
      let progress = 0;
      let total = 1;

      if (this.proposal.gantData.length == 0) return 0;

      total += this.proposal.gantData.length * 4;

      this.proposal.gantData.forEach((x) => {
        x.description ? progress++ : 1;
        x.percent == 0 || x.percent ? progress++ : 1;
        x.startDate ? progress++ : 1;
        x.dueDate ? progress++ : 1;
      });

      this.proposal.gantData
        .map((x) => x.percent)
        .reduce((a, b) => Number(a) + Number(b), 0) == 100
        ? progress++
        : 1;

      progress = parseInt((progress / total) * 100);
      return progress;
    },

    step7progress() {
      // NOTE (c-step7Progress) previous
      let progress = 0;
      let total = 0; //default number of price variables due to last table

      if (this.proposal.personnelCosts.length > 0) {
        total += this.proposal.personnelCosts.length * 5;
        this.proposal.personnelCosts.forEach((x) => {
          x.name ? progress++ : 1;
          x.degree ? progress++ : 1;
          x.cooperationType ? progress++ : 1;
          x.cooperationHour ? progress++ : 1;
          x.perPersonCost ? progress++ : 1;
        });
      }
      if (this.proposal.travelExpenses.length > 0) {
        total += this.proposal.travelExpenses.length * 4;
        this.proposal.travelExpenses.forEach((x) => {
          x.destination ? progress++ : 1;
          x.reason ? progress++ : 1;
          x.number ? progress++ : 1;
          // x.day ? progress++ : 1;
          x.cost ? progress++ : 1;
        });
      }
      if (this.proposal.purchases.length > 0) {
        total += this.proposal.purchases.length * 5;
        this.proposal.purchases.forEach((x) => {
          x.name ? progress++ : 1;
          // x.consumable ? progress++ : 1;
          // x.fund ? progress++ : 1;
          x.type ? progress++ : 1;
          x.source ? progress++ : 1;
          x.number ? progress++ : 1;
          x.perPrice ? progress++ : 1;
        });
      }

      if (this.proposal.participationOrganizationBudget.length > 0) {
        total += this.proposal.participationOrganizationBudget.length * 2;
        this.proposal.participationOrganizationBudget.forEach((x) => {
          x.name ? progress++ : 1;
          x.description ? progress++ : 1;
        });
      }

      // if (this.proposal.otherCosts.length > 0) {
      //   total += this.proposal.otherCosts.length * 3;
      //   this.proposal.otherCosts[0].totalPrice ? progress++ : 1;
      //   this.proposal.otherCosts[1].totalPrice ? progress++ : 1;
      //   this.proposal.otherCosts[2].totalPrice ? progress++ : 1;
      // }

      return total == 0 ? 0 : parseInt((progress / total) * 100);
    },

    step8progress() {
      // NOTE (c-step9Progress) previous
      let progress = 0;

      this.proposal.letterUniversityAccountNumberFile ? progress++ : 1;
      this.proposal.letterUniversityResearchFile ? progress++ : 1;
      this.proposal.postDocApplicationDocumentationFile ? progress++ : 1;
      this.proposal.postDocArticle1File ? progress++ : 1;
      this.proposal.postDocArticle2File ? progress++ : 1;
      this.proposal.postDocArticle3File ? progress++ : 1;
      this.proposal.postDocArticle4File ? progress++ : 1;
      this.proposal.postDocArticle5File ? progress++ : 1;

      this.proposal.postDocPhDCertificateFile ? progress++ : 1;
      this.proposal.postDocProfessorFacultyMembershipFile ? progress++ : 1;
      this.proposal.postDocResearchFestivalFile ? progress++ : 1;
      this.proposal.postDocResearchFestivalFileDescription ? progress++ : 1;
      this.proposal.postDocResearchFestivalFileTitle ? progress++ : 1;
      this.proposal.postDocResearcherResumeEnFileIdFile ? progress++ : 1;
      this.proposal.postDocResearcherResumeFaFileIdFile ? progress++ : 1;
      this.proposal.postDocTeacherResumeEnFile ? progress++ : 1;
      this.proposal.postDocTeacherResumeFaFile ? progress++ : 1;
      this.proposal.postDocIntroductionLetterFile ? progress++ : 1;
      this.proposal.universityAgreementIndustryFile ? progress++ : 1;

      return parseInt((progress / 19) * 100);
    },

    step9progress() {
      // NOTE (c-step10Progress) previous
      let progress = 0;
      for (let i = 0; i <= 13; i++) {
        this.proposal.promiseArrays[i] ? progress++ : 1;
      }
      return parseInt((progress / 14) * 100);
    },

    lastStepProgress() {
      // NOTE (c-lastStepProgress) previous
      let wholeSteps = 0;
      for (let i = 1; i <= 9; i++) {
        wholeSteps += this["step" + i + "progress"];
      }
      // x => (wholeSteps += this["step" + x + "progress"])

      return parseInt(wholeSteps / 9);
    },

    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }

      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.getStatesAndCities();
    this.onMounted();
  },
  updated() {},
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
